webpackJsonp([7,23,28,55],{

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_footer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_achievements__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sidebar__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_modalPdf__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal_modalStudentCard__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_appBus__ = __webpack_require__(124);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Main',
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: {
    isEC: function isEC() {
      return this.$store.getters['isEC'];
    }
  },
  methods: {
    setShowMenu: function setShowMenu(show) {
      this.showMenu = show;
    },
    goTo: function goTo(route) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setShowMenu(false);
                _context.next = 3;
                return _this.$delay(200);

              case 3:
                _this.$router.push({ name: route });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showFiles: function showFiles() {
      this.setShowMenu(false);
      this.$store.commit('setShowPdf', true);
    },
    showStudentCard: function showStudentCard() {
      this.setShowMenu(false);
      this.$store.commit('setShowStudentCard', true);
    },
    logout: function logout() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.setShowMenu(false);
                _context2.next = 3;
                return _this2.$delay(200);

              case 3:
                _context2.next = 5;
                return _this2.$store.dispatch('auth/logout');

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  components: {
    headerComponent: __WEBPACK_IMPORTED_MODULE_2__components_header__["default"],
    footerComponent: __WEBPACK_IMPORTED_MODULE_3__components_footer__["default"],
    achievementsComponent: __WEBPACK_IMPORTED_MODULE_4__components_achievements__["default"],
    sidebarComponent: __WEBPACK_IMPORTED_MODULE_5__components_sidebar__["default"],
    modalPdf: __WEBPACK_IMPORTED_MODULE_6__components_modal_modalPdf__["a" /* default */],
    modalStudentCard: __WEBPACK_IMPORTED_MODULE_7__components_modal_modalStudentCard__["a" /* default */]
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_8__plugins_appBus__["a" /* default */].$on('showMenu', this.setShowMenu);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_8__plugins_appBus__["a" /* default */].$off('showMenu', this.setShowMenu);
  }
});

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoaderModal',
  data: function data() {
    return {
      rotateCard: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.getters['showStudentCard'];
    },
    student: function student() {
      return this.$store.getters['student/GET'];
    }
  },
  methods: {}
});

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1279);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("d770dad2", content, true, {});

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".main__menu[data-v-f7b59590]{position:fixed;top:0;left:0;background-color:rgba(19,0,0,.95);width:100vw;height:100%;z-index:150;display:-webkit-box;display:-ms-flexbox;display:flex}.main__menu__icon[data-v-f7b59590]{position:absolute;top:5vh;right:5vw;height:60px;width:60px;color:#fc7f7f;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;cursor:pointer}.main__menu__icon[data-v-f7b59590]:hover{-webkit-transform:scale(1.2) rotate(90deg);transform:scale(1.2) rotate(90deg)}.main__menu ul[data-v-f7b59590]{list-style-type:none;margin:0 auto;margin-top:25vh;text-align:center}.main__menu ul li[data-v-f7b59590]{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;font-size:35px;font-weight:300;letter-spacing:1px;color:#f1f1f1;cursor:pointer}.main__menu ul li[data-v-f7b59590]:hover{-webkit-transform:scale(1.2);transform:scale(1.2)}.main__menu ul li hr[data-v-f7b59590]{margin:20px 0;min-width:100%;color:#ffa216;height:3px;background-color:#ffa216;border:none}.show-menu-enter-active[data-v-f7b59590]{-webkit-animation:opaque .2s ease backwards;animation:opaque .2s ease backwards;-webkit-animation-delay:.2s;animation-delay:.2s}.show-menu-leave-active[data-v-f7b59590]{animation:opaque .2s ease reverse backwards}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/pages/main/index.vue"],"names":[],"mappings":"AACA,6BACE,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,kCAAuC,AACvC,YAAa,AACb,YAAa,AACb,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,mCACI,kBAAmB,AACnB,QAAS,AACT,UAAW,AACX,YAAa,AACb,WAAY,AACZ,cAAe,AACf,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,+CAAiD,AACjD,cAAgB,CACnB,AACD,yCACM,2CAA4C,AACpC,kCAAoC,CACjD,AACD,gCACI,qBAAsB,AACtB,cAAe,AACf,gBAAiB,AACjB,iBAAmB,CACtB,AACD,mCACM,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,+CAAiD,AACjD,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,cAAe,AACf,cAAgB,CACrB,AACD,yCACQ,6BAA8B,AACtB,oBAAsB,CACrC,AACD,sCACQ,cAAe,AACf,eAAgB,AAChB,cAAe,AACf,WAAY,AACZ,yBAA0B,AAC1B,WAAa,CACpB,AACD,yCACE,4CAA6C,AACrC,oCAAqC,AAC7C,4BAA6B,AACrB,mBAAqB,CAC9B,AACD,yCACE,2CAA6C,CAC9C","file":"index.vue","sourcesContent":["\n.main__menu[data-v-f7b59590] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(19, 0, 0, 0.95);\n  width: 100vw;\n  height: 100%;\n  z-index: 150;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.main__menu__icon[data-v-f7b59590] {\n    position: absolute;\n    top: 5vh;\n    right: 5vw;\n    height: 60px;\n    width: 60px;\n    color: #fc7f7f;\n    -webkit-transition: -webkit-transform .2s;\n    transition: -webkit-transform .2s;\n    transition: transform .2s;\n    transition: transform .2s, -webkit-transform .2s;\n    cursor: pointer;\n}\n.main__menu__icon[data-v-f7b59590]:hover {\n      -webkit-transform: scale(1.2) rotate(90deg);\n              transform: scale(1.2) rotate(90deg);\n}\n.main__menu ul[data-v-f7b59590] {\n    list-style-type: none;\n    margin: 0 auto;\n    margin-top: 25vh;\n    text-align: center;\n}\n.main__menu ul li[data-v-f7b59590] {\n      -webkit-transition: -webkit-transform .2s;\n      transition: -webkit-transform .2s;\n      transition: transform .2s;\n      transition: transform .2s, -webkit-transform .2s;\n      font-size: 35px;\n      font-weight: 300;\n      letter-spacing: 1px;\n      color: #f1f1f1;\n      cursor: pointer;\n}\n.main__menu ul li[data-v-f7b59590]:hover {\n        -webkit-transform: scale(1.2);\n                transform: scale(1.2);\n}\n.main__menu ul li hr[data-v-f7b59590] {\n        margin: 20px 0;\n        min-width: 100%;\n        color: #ffa216;\n        height: 3px;\n        background-color: #ffa216;\n        border: none;\n}\n.show-menu-enter-active[data-v-f7b59590] {\n  -webkit-animation: opaque .2s ease backwards;\n          animation: opaque .2s ease backwards;\n  -webkit-animation-delay: .2s;\n          animation-delay: .2s;\n}\n.show-menu-leave-active[data-v-f7b59590] {\n  animation: opaque .2s ease reverse backwards;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalStudentCard_vue__ = __webpack_require__(1149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf2e490c_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalStudentCard_vue__ = __webpack_require__(1283);
function injectStyle (ssrContext) {
  __webpack_require__(1281)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf2e490c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalStudentCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf2e490c_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalStudentCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1282);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("5f8cd7c7", content, true, {});

/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".modal-student-card[data-v-bf2e490c]{height:100vh;width:100vw;position:fixed;top:0;left:0;z-index:125}.modal-student-card__close[data-v-bf2e490c]{width:100%;padding-bottom:5px}.modal-student-card__close button#back_student-card svg[data-v-bf2e490c],.modal-student-card__close button#close_student-card svg[data-v-bf2e490c]{font-size:32px}.modal-student-card__box[data-v-bf2e490c]{width:calc(100% - 20px);margin:10px}.modal-student-card__box__card[data-v-bf2e490c]{width:322px;height:200px;background:transparent;position:relative;-webkit-transition:-webkit-transform .6s;transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-box-shadow:0 4px 8px 0 rgba(0,0,0,.2);box-shadow:0 4px 8px 0 rgba(0,0,0,.2);border-radius:20px}.modal-student-card__box__card__front[data-v-bf2e490c]{width:100%;height:100%;position:absolute;background:-webkit-gradient(linear,right top,left top,from(#cd1f26),to(#c50737));background:linear-gradient(270deg,#cd1f26,#c50737);-webkit-backface-visibility:hidden;backface-visibility:hidden;border-radius:20px}.modal-student-card__box__card__front__name[data-v-bf2e490c]{font-size:18px}.modal-student-card__box__card__front__birth[data-v-bf2e490c]{font-size:14px}.modal-student-card__box__card__back[data-v-bf2e490c]{width:100%;height:100%;position:absolute;background:-webkit-gradient(linear,right top,left top,from(#01699e),to(#06355d));background:linear-gradient(270deg,#01699e,#06355d);-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:rotateY(180deg);transform:rotateY(180deg);border-radius:20px}.modal-student-card__box__card__back__score[data-v-bf2e490c]{text-align:right;font-size:14px}.modal-student-card__box__card.rotate[data-v-bf2e490c]{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/modal/modalStudentCard.vue"],"names":[],"mappings":"AACA,qCACE,aAAc,AACd,YAAa,AACb,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,WAAa,CACd,AACD,4CACI,WAAY,AACZ,kBAAoB,CACvB,AACD,mJAEM,cAAgB,CACrB,AACD,0CACI,wBAAyB,AACzB,WAAa,CAChB,AACD,gDACM,YAAa,AACb,aAAc,AACd,uBAAwB,AACxB,kBAAmB,AACnB,yCAA2C,AAC3C,iCAAmC,AACnC,yBAA2B,AAC3B,+CAAmD,AACnD,oCAAqC,AAC7B,4BAA6B,AACrC,8CAAmD,AAC3C,sCAA2C,AACnD,kBAAoB,CACzB,AACD,uDACQ,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,iFAAsF,AACtF,mDAAyD,AACzD,mCAAoC,AAC5B,2BAA4B,AACpC,kBAAoB,CAC3B,AACD,6DACU,cAAgB,CACzB,AACD,8DACU,cAAgB,CACzB,AACD,sDACQ,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,iFAAsF,AACtF,mDAAyD,AACzD,mCAAoC,AAC5B,2BAA4B,AACpC,kCAAmC,AAC3B,0BAA2B,AACnC,kBAAoB,CAC3B,AACD,6DACU,iBAAkB,AAClB,cAAgB,CACzB,AACD,uDACQ,kCAAmC,AAC3B,yBAA2B,CAC1C","file":"modalStudentCard.vue","sourcesContent":["\n.modal-student-card[data-v-bf2e490c] {\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 125;\n}\n.modal-student-card__close[data-v-bf2e490c] {\n    width: 100%;\n    padding-bottom: 5px;\n}\n.modal-student-card__close button#close_student-card svg[data-v-bf2e490c],\n    .modal-student-card__close button#back_student-card svg[data-v-bf2e490c] {\n      font-size: 32px;\n}\n.modal-student-card__box[data-v-bf2e490c] {\n    width: calc(100% - 20px);\n    margin: 10px;\n}\n.modal-student-card__box__card[data-v-bf2e490c] {\n      width: 322px;\n      height: 200px;\n      background: transparent;\n      position: relative;\n      -webkit-transition: -webkit-transform 0.6s;\n      transition: -webkit-transform 0.6s;\n      transition: transform 0.6s;\n      transition: transform 0.6s, -webkit-transform 0.6s;\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n      -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n      border-radius: 20px;\n}\n.modal-student-card__box__card__front[data-v-bf2e490c] {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        background: -webkit-gradient(linear, right top, left top, from(#CD1F26), to(#C50737));\n        background: linear-gradient(270deg, #CD1F26 0%, #C50737);\n        -webkit-backface-visibility: hidden;\n                backface-visibility: hidden;\n        border-radius: 20px;\n}\n.modal-student-card__box__card__front__name[data-v-bf2e490c] {\n          font-size: 18px;\n}\n.modal-student-card__box__card__front__birth[data-v-bf2e490c] {\n          font-size: 14px;\n}\n.modal-student-card__box__card__back[data-v-bf2e490c] {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        background: -webkit-gradient(linear, right top, left top, from(#01699e), to(#06355d));\n        background: linear-gradient(270deg, #01699e 0%, #06355d);\n        -webkit-backface-visibility: hidden;\n                backface-visibility: hidden;\n        -webkit-transform: rotateY(180deg);\n                transform: rotateY(180deg);\n        border-radius: 20px;\n}\n.modal-student-card__box__card__back__score[data-v-bf2e490c] {\n          text-align: right;\n          font-size: 14px;\n}\n.modal-student-card__box__card.rotate[data-v-bf2e490c] {\n        -webkit-transform: rotateY(180deg);\n                transform: rotateY(180deg);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal-student-card bg-color container column justify-content-center align-items-center"},[_c('div',{staticClass:"modal-student-card__close container padding-10 justify-content-end"},[_c('button',{staticClass:"btn btn-sm btn-blue btn-rounded",attrs:{"id":"close_student-card"},on:{"click":function($event){return _vm.$store.commit('setShowStudentCard', false)}}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-student-card__box container padding-10 justify-content-center align-center flex-grow-1"},[_c('div',{staticClass:"modal-student-card__box__card container",class:{ rotate: _vm.rotateCard },on:{"click":function($event){_vm.rotateCard = !_vm.rotateCard}}},[_c('div',{staticClass:"modal-student-card__box__card__front flex-grow-1 container column justify-content-end padding-20"},[_c('div',[_c('img',{staticClass:"logo",staticStyle:{"float":"right"},attrs:{"src":__webpack_require__(662),"width":"137","alt":"Minds"}})]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('div',{staticClass:"modal-student-card__box__card__front__name"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.student.name)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"modal-student-card__box__card__front__birth"},[_vm._v("\n\t\t\t\t\t\tNascimento: "+_vm._s(new Date(_vm.student.birth).toLocaleDateString())+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"modal-student-card__box__card__back flex-grow-1 container column justify-content-end padding-20"},[_c('div',[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(662),"width":"137","alt":"Minds"}})]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('div',{staticClass:"modal-student-card__box__card__back__score"},[_vm._v("\n\t\t\t\t\t\tPontos: "+_vm._s(_vm.student.score)+"\n\t\t\t\t\t")])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('headerComponent'),_vm._v(" "),(_vm.$route.meta.intro)?_c('router-view'):(_vm.$route.meta.game)?_c('div',{staticClass:"size margin",class:{ 'size--ec': _vm.isEC }},[_c('router-view',{staticClass:"animation-bottom animation-delay-01"})],1):_c('div',{staticClass:"size margin container align-items-stretch wrap justify-content-center"},[_c('div',{staticClass:"col-12 col-xl-9 col-lg-9 col-md-8 col-sm-12 container column"},[_c('achievementsComponent',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]}),_vm._v(" "),_c('router-view',{staticClass:"animation-bottom animation-delay-01"})],1),_vm._v(" "),_c('sidebarComponent')],1),_vm._v(" "),_c('footerComponent'),_vm._v(" "),_c('transition',{attrs:{"name":"show-menu"}},[(_vm.showMenu)?_c('div',{staticClass:"main__menu",on:{"click":function($event){_vm.showMenu = false}}},[_c('font-awesome-icon',{staticClass:"main__menu__icon",attrs:{"icon":"times"},on:{"click":function($event){return _vm.setShowMenu(false)}}}),_vm._v(" "),_c('ul',[_c('li',{on:{"click":function($event){return _vm.goTo('perfil')}}},[_c('span',[_vm._v("Perfil")])]),_vm._v(" "),_c('li',[_c('hr')]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.goTo('financeiro')}}},[_c('span',[_vm._v("Financeiro")])]),_vm._v(" "),_c('li',[_c('hr')]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.goTo('vouchers')}}},[_c('span',[_vm._v("Vouchers")])]),_vm._v(" "),_c('li',[_c('hr')]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.showFiles()}}},[_c('span',[_vm._v("Files")])]),_vm._v(" "),_c('li',[_c('hr')]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.showStudentCard()}}},[_c('span',[_vm._v("Card")])]),_vm._v(" "),_c('li',[_c('hr')]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.logout()}}},[_c('span',[_vm._v("Logout")])])])],1):_vm._e()]),_vm._v(" "),_c('modalPdf'),_vm._v(" "),_c('modalStudentCard')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(680);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9ed4e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(770);
function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31e9ed4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9ed4e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(725);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c85fbffc_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(808);
function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c85fbffc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c85fbffc_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(729);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abed402e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(825);
function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-abed402e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abed402e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(797);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae2f95a_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(894);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae2f95a_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1148);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7b59590_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1284);
function injectStyle (ssrContext) {
  __webpack_require__(1278)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7b59590"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7b59590_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bloogApprentice.075b01d.png";

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQ0OCA0NDgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ0OCA0NDg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRkZGRkY7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MzMuOSwxOTBsLTEyOC0xMjhjLTE4LjgtMTguOC00OS4xLTE4LjgtNjcuOSwwYy0xOC44LDE4LjctMTguOCw0OS4yLDAsNjcuOWw5NCw5NC4xbC05NCw5NA0KCQljLTE4LjgsMTguOC0xOC44LDQ5LjEsMCw2Ny45YzkuMyw5LjQsMjEuNiwxNC4xLDMzLjksMTQuMXMyNC42LTQuNywzNC0xNGwxMjgtMTI4QzQ1Mi43LDIzOS4yLDQ1Mi43LDIwOC44LDQzMy45LDE5MHoiLz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjA5LjksMTkwTDgxLjksNjJjLTE4LjgtMTguOC00OS4xLTE4LjgtNjcuOSwwYy0xOC44LDE4LjctMTguOCw0OS4yLDAsNjcuOWw5NCw5NC4xbC05NCw5NA0KCQljLTE4LjgsMTguOC0xOC44LDQ5LjEsMCw2Ny45QzIzLjQsMzk1LjMsMzUuNyw0MDAsNDgsNDAwczI0LjYtNC43LDM0LTE0bDEyOC0xMjhDMjI4LjcsMjM5LjIsMjI4LjcsMjA4LjgsMjA5LjksMTkweiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'metaPercentage',
  data: function data() {
    return {};
  },

  props: {
    percentage: {
      type: String
    },
    borderRadius: {
      type: String,
      default: '20'
    },
    height: {
      type: String,
      default: '10'
    }
  }
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


//

// Check if the request came from the browser and is not server rendered
if (typeof window !== 'undefined') {
  Promise.resolve().then(function () { return slick$1; });
}

var script = {
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },

  mounted: function() {
    this.create();
  },

  destroyed: function() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('unslick');
  },

  methods: {
    create: function() {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el);

      $slick.on('afterChange', this.onAfterChange);
      $slick.on('beforeChange', this.onBeforeChange);
      $slick.on('breakpoint', this.onBreakpoint);
      $slick.on('destroy', this.onDestroy);
      $slick.on('edge', this.onEdge);
      $slick.on('init', this.onInit);
      $slick.on('reInit', this.onReInit);
      $slick.on('setPosition', this.onSetPosition);
      $slick.on('swipe', this.onSwipe);
      $slick.on('lazyLoaded', this.onLazyLoaded);
      $slick.on('lazyLoadError', this.onLazyLoadError);

      $slick.slick(this.options);
    },

    destroy: function() {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el);

      $slick.off('afterChange', this.onAfterChange);
      $slick.off('beforeChange', this.onBeforeChange);
      $slick.off('breakpoint', this.onBreakpoint);
      $slick.off('destroy', this.onDestroy);
      $slick.off('edge', this.onEdge);
      $slick.off('init', this.onInit);
      $slick.off('reInit', this.onReInit);
      $slick.off('setPosition', this.onSetPosition);
      $slick.off('swipe', this.onSwipe);
      $slick.off('lazyLoaded', this.onLazyLoaded);
      $slick.off('lazyLoadError', this.onLazyLoadError);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('unslick');
    },

    reSlick: function() {
      this.destroy();
      this.create();
    },

    next: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickNext');
    },

    prev: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickPrev');
    },

    pause: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickPause');
    },

    play: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickPlay');
    },

    goTo: function(index, dontAnimate) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickGoTo', index, dontAnimate);
    },

    currentSlide: function() {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickCurrentSlide');
    },

    add: function(element, index, addBefore) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickAdd', element, index, addBefore);
    },

    remove: function(index, removeBefore) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickRemove', index, removeBefore);
    },

    filter: function(filterData) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickFilter', filterData);
    },

    unfilter: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickUnfilter');
    },

    getOption: function(option) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickGetOption', option);
    },

    setOption: function(option, value, refresh) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickSetOption', option, value, refresh);
    },

    setPosition: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('setPosition');
    },

    // Events
    onAfterChange: function(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },

    onBeforeChange: function(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    },

    onBreakpoint: function(event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint);
    },

    onDestroy: function(event, slick) {
      this.$emit('destroy', event, slick);
    },

    onEdge: function(event, slick, direction) {
      this.$emit('edge', event, slick, direction);
    },

    onInit: function(event, slick) {
      this.$emit('init', event, slick);
    },

    onReInit: function(event, slick) {
      this.$emit('reInit', event, slick);
    },

    onSetPosition: function(event, slick) {
      this.$emit('setPosition', event, slick);
    },

    onSwipe: function(event, slick, direction) {
      this.$emit('swipe', event, slick, direction);
    },

    onLazyLoaded: function(event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource);
    },

    onLazyLoadError: function(event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource);
    },
  },

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_vm._t("default")], 2)
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Slick = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var install = function installMyComponent(Vue, opt) {
  // Don't install if already installed, or SSR
  if (install.installed || Vue.prototype.$isServer) { return }
  install.installed = true;

  Vue.component('slick', Slick);
};

// Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()
Slick.install = install;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var slick = createCommonjsModule(function (module, exports) {
(function(factory) {
    {
        module.exports = factory(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
    }

}(function($$$1) {
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $$$1(element),
                appendDots: $$$1(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $$$1('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $$$1.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $$$1(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $$$1(element).data('slick') || {};

            _.options = $$$1.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $$$1.proxy(_.autoPlay, _);
            _.autoPlayClear = $$$1.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $$$1.proxy(_.autoPlayIterator, _);
            _.changeSlide = $$$1.proxy(_.changeSlide, _);
            _.clickHandler = $$$1.proxy(_.clickHandler, _);
            _.selectHandler = $$$1.proxy(_.selectHandler, _);
            _.setPosition = $$$1.proxy(_.setPosition, _);
            _.swipeHandler = $$$1.proxy(_.swipeHandler, _);
            _.dragHandler = $$$1.proxy(_.dragHandler, _);
            _.keyHandler = $$$1.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $$$1(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $$$1(markup).insertBefore(_.$slides.eq(index));
            } else {
                $$$1(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $$$1(markup).prependTo(_.$slideTrack);
            } else {
                $$$1(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $$$1(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $$$1({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $$$1(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $$$1(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $$$1(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $$$1(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $$$1('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($$$1('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $$$1(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $$$1(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $$$1('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $$$1('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $$$1(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $$$1.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $$$1.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $$$1(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $$$1('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $$$1.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $$$1(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $$$1(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $$$1(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $$$1(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $$$1('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $$$1(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $$$1.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $$$1('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $$$1(this).attr('style', $$$1(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $$$1(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1;

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2;
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($$$1(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($$$1(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$$$1(_.$slider).hasClass('slick-initialized')) {

            $$$1(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $$$1(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                   if ($$$1('#' + ariaButtonControl).length) {
                     $$$1(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $$$1(this).attr({
                    'role': 'presentation'
                });

                $$$1(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $$$1('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $$$1('li', _.$dots)
                .on('mouseenter.slick', $$$1.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $$$1.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $$$1(document).on(_.visibilityChange, $$$1.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $$$1(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $$$1(window).on('orientationchange.slick.slick-' + _.instanceUid, $$$1.proxy(_.orientationChange, _));

        $$$1(window).on('resize.slick.slick-' + _.instanceUid, $$$1.proxy(_.resize, _));

        $$$1('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $$$1(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $$$1(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $$$1('img[data-lazy]', imagesScope).each(function() {

                var image = $$$1(this),
                    imageSource = $$$1(this).attr('data-lazy'),
                    imageSrcSet = $$$1(this).attr('data-srcset'),
                    imageSizes  = $$$1(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) { rangeStart--; }
                if (rangeEnd <= _.slideCount) { rangeEnd++; }
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) { prevSlide = _.slideCount - 1; }
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $$$1(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $$$1( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $$$1.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $$$1.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $$$1(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($$$1(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $$$1(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) { _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset); }

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $$$1(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $$$1(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $$$1.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $$$1.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $$$1.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $$$1.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $$$1.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) { _.animType = false; }
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) { _.animType = false; }
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) { _.animType = false; }
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) { _.animType = false; }
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $$$1(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $$$1(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $$$1(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $$$1(event.target).is('.slick-slide') ?
                $$$1(event.target) :
                $$$1(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) { index = 0; }

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $$$1('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $$$1.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                { _[i].slick = new Slick(_[i], opt); }
            else
                { ret = _[i].slick[opt].apply(_[i].slick, args); }
            if (typeof ret != 'undefined') { return ret; }
        }
        return _;
    };

}));
});

var slick$1 = /*#__PURE__*/Object.freeze({
  default: slick,
  __moduleExports: slick
});

/* harmony default export */ __webpack_exports__["a"] = (Slick);


/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.0617d53.svg";

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2022-08-26T17:52Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		// trim whitespace for custom property (issue gh-4926)
		if ( isCustomProp ) {

			// rtrim treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" );
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(674), __esModule: true };

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(675);
module.exports = __webpack_require__(9).Math.trunc;


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(29);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_appBus__ = __webpack_require__(124);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userContent',
  data: function data() {
    return {
      student: {
        image: 'user',
        imageType: 'png'
      }
    };
  },

  props: {
    data: {
      type: Object,
      default: { name: 'Default' }
    }
  },
  computed: {
    user: function user() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.student, this.data);
    }
  },
  methods: {
    showMenu: function showMenu() {
      __WEBPACK_IMPORTED_MODULE_1__plugins_appBus__["a" /* default */].$emit('showMenu', true);
    }
  }
});

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    year: function year() {
      var today = new Date();

      return today.getUTCFullYear();
    }
  }
});

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkZCRjAwO30NCjwvc3R5bGU+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDk4LjIsMjIyLjdDNDk4LjIsMjIyLjcsNDk4LjIsMjIyLjcsNDk4LjIsMjIyLjdMMjg5LjMsMTMuOEMyODAuNCw0LjksMjY4LjYsMCwyNTYsMHMtMjQuNCw0LjktMzMuMywxMy44DQoJTDEzLjksMjIyLjZjLTAuMSwwLjEtMC4xLDAuMS0wLjIsMC4yYy0xOC4zLDE4LjQtMTguMyw0OC4yLDAuMSw2Ni42YzguNCw4LjQsMTkuNCwxMy4yLDMxLjMsMTMuN2MwLjUsMCwxLDAuMSwxLjUsMC4xaDguM3YxNTMuNw0KCWMwLDMwLjQsMjQuNyw1NS4yLDU1LjIsNTUuMmg4MS43YzguMywwLDE1LTYuNywxNS0xNVYzNzYuNWMwLTEzLjksMTEuMy0yNS4yLDI1LjItMjUuMmg0OC4yYzEzLjksMCwyNS4yLDExLjMsMjUuMiwyNS4yVjQ5Nw0KCWMwLDguMyw2LjcsMTUsMTUsMTVINDAyYzMwLjQsMCw1NS4yLTI0LjcsNTUuMi01NS4yVjMwMy4xaDcuN2MxMi42LDAsMjQuNC00LjksMzMuMy0xMy44QzUxNi41LDI3MSw1MTYuNSwyNDEuMSw0OTguMiwyMjIuN3oiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRkJGMDA7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTk2LDQ0Mi42di0zMjlDMTQ1LjUsMTAwLjEsOTMuNiw5My4zLDQxLjEsOTMuM0gxNWMtOC4zLDAtMTUsNi43LTE1LDE1djMwMGMwLDguMyw2LjcsMTUsMTUsMTVoMjYuMQ0KCQkJYzUyLjUsMCwxMDQuNSw3LjIsMTU0LjksMjEuNUMxOTYsNDQ0LDE5Niw0NDMuMywxOTYsNDQyLjZ6Ii8+DQoJPC9nPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDk3LDkzLjNoLTI2LjFjLTUyLjUsMC0xMDQuNCw2LjgtMTU0LjksMjAuM2MwLDAsMCwzMzAuNCwwLDMzMS4xYzUwLjQtMTQuMywxMDIuNC0yMS41LDE1NC45LTIxLjVINDk3DQoJCQljOC4zLDAsMTUtNi43LDE1LTE1di0zMDBDNTEyLDEwMCw1MDUuMyw5My4zLDQ5Nyw5My4zeiIvPg0KCTwvZz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI1Niw0NzcuOGMtMjAuOCwwLTMwLTE3LjgtMzAtMjQuNnYtMzMwYzIuOSwxNC43LDE1LDI0LjYsMzAsMjQuNnMyNy4xLTkuOSwzMC0yNC42djMzMA0KCQkJQzI4Niw0NjAsMjc2LjgsNDc3LjgsMjU2LDQ3Ny44TDI1Niw0NzcuOHoiLz4NCgk8L2c+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ2MC4zLDYzLjRjLTY0LjIsMS4xLTEyNy42LDExLjktMTg4LjUsMzIuMmMtNiwyLTExLjMsNS4xLTE1LjgsOS4yYy00LjUtNC05LjgtNy4yLTE1LjgtOS4yDQoJCWMtNjEtMjAuMy0xMjQuMy0zMS4yLTE4OC42LTMyLjJsMTAuNS0yMC45YzIuNy01LjMsOC4zLTguNiwxNC4yLTguM2MxMDEuMyw1LjQsMTc0LDMzLjUsMTc5LjcsMzVjMy0wLjgsODEuNC0yOS44LDE3OS43LTM1DQoJCWM2LTAuMywxMS41LDIuOSwxNC4yLDguM0w0NjAuMyw2My40eiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkZCRjAwO30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ3OC42LDkxLjlWNTAuMWMwLTI3LjYtMjIuNS01MC4xLTUwLjEtNTAuMWgtMzQ1QzU1LjksMCwzMy40LDIyLjUsMzMuNCw1MC4xdjQxLjhDMTQsOTguOCwwLDExNy40LDAsMTM5LjENCgkJCXYzNTYuMmMwLDkuMiw3LjUsMTYuNywxNi43LDE2LjdoNDc4LjZjOS4yLDAsMTYuNy03LjUsMTYuNy0xNi43VjEzOS4xQzUxMiwxMTcuNCw0OTgsOTguOCw0NzguNiw5MS45eiBNMjIyLjYsMTIyLjRoNjYuOHYzMy40DQoJCQljMCwxOC40LTE1LDMzLjQtMzMuNCwzMy40cy0zMy40LTE1LTMzLjQtMzMuNEwyMjIuNiwxMjIuNEwyMjIuNiwxMjIuNHogTTg5LDQ3OC42SDMzLjRWMjE4LjhjNy4xLDIuNSwxNC42LDMuOCwyMi4zLDMuOA0KCQkJYzEyLjIsMCwyMy42LTMuMywzMy40LTlMODksNDc4LjZMODksNDc4LjZ6IE04OSwxNTUuOGMwLDE4LjQtMTUsMzMuNC0zMy40LDMzLjRjLTguMywwLTE2LjItMy4xLTIyLjMtOC41di00MS42DQoJCQljMC05LjIsNy41LTE2LjcsMTYuNy0xNi43aDM5TDg5LDE1NS44TDg5LDE1NS44eiBNMTIyLjQsMTU1Ljh2LTMzLjRoNjYuOHYzMy40YzAsMTguNC0xNSwzMy40LTMzLjQsMzMuNA0KCQkJQzEzNy40LDE4OS4yLDEyMi40LDE3NC4yLDEyMi40LDE1NS44eiBNMjkzLjEsNDI5LjVjLTguMiw3LjItMTYuNywxNC41LTI1LjgsMjIuNmMtMy4yLDIuOC03LjEsNC4yLTExLjEsNC4yDQoJCQljLTQsMC03LjktMS40LTExLjEtNC4yYy05LTguMS0xNy41LTE1LjUtMjUuOC0yMi42Yy00Ni4zLTQwLjItNzkuOC02OS4zLTc5LjgtMTEyLjRjMC0xOSw2LjQtMzYuOCwxOC01MC4yDQoJCQljMTIuNS0xNC40LDI5LjgtMjIuNCw0OC43LTIyLjRjMTkuNywwLDM2LjksOC44LDUwLDI1LjVjMTMuMS0xNi43LDMwLjMtMjUuNSw1MC0yNS41YzE5LDAsMzYuMyw3LjksNDguNywyMi40DQoJCQljMTEuNiwxMy40LDE4LDMxLjIsMTgsNTAuMkMzNzIuOSwzNjAuMiwzMzkuNCwzODkuMywyOTMuMSw0MjkuNXogTTM4OS42LDE1NS44YzAsMTguNC0xNSwzMy40LTMzLjQsMzMuNHMtMzMuNC0xNS0zMy40LTMzLjQNCgkJCXYtMzMuNGg2Ni44TDM4OS42LDE1NS44TDM4OS42LDE1NS44eiBNNDc4LjYsNDc4LjZINDIzdi0yNjVjOS44LDUuNywyMS4yLDksMzMuNCw5YzcuNywwLDE1LjItMS4zLDIyLjMtMy44TDQ3OC42LDQ3OC42DQoJCQlMNDc4LjYsNDc4LjZ6IE00NzguNiwxODAuN2MtNi4xLDUuNS0xMy45LDguNS0yMi4zLDguNWMtMTguNCwwLTMzLjQtMTUtMzMuNC0zMy40di0zMy40aDM5YzkuMiwwLDE2LjcsNy41LDE2LjcsMTYuN1YxODAuN3oiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjMDBiNWQ3IiBkPSJNMjU1Ljk5NiA0OTIuMjM2bDI0OC4zOTYtMzA4Ljk5OC05NC44NzktMTYzLjQ3OUgxMDIuNDhMNy42IDE4My4yMzh6Ii8+PHBhdGggZD0iTTM2MS40MjggMTgzLjIzMUwyNTUuOTk2IDQ5Mi4yMzYgMTUwLjU2NSAxODMuMjMxem00OC4wODctMTYzLjQ3NWw5NC44NzcgMTYzLjQ3NUgzNjEuNDI4TDMyNy45NyAxOS43NTZ6bS0yMjUuNDkzIDBsLTMzLjQ1NyAxNjMuNDc1SDcuNmw5NC44NzgtMTYzLjQ3NXoiIGZpbGw9IiM3MmQ0ZmYiLz48cGF0aCBkPSJNNTEwLjk3MSAxNzkuNDE5TDQxNi4wOTQgMTUuOTQ0YTcuNjAzIDcuNjAzIDAgMCAwLTYuNTc2LTMuNzg3SDEwMi40ODFhNy42MDYgNy42MDYgMCAwIDAtNi41NzcgMy43ODdMNTMuMDIyIDg5LjgyN2E3LjYwNCA3LjYwNCAwIDEgMCAxMy4xNTMgNy42MzRsNDAuNjgzLTcwLjA5N2g2Ny44NDZsLTMwLjM0MyAxNDguMjdIMjAuODA4bDI3LjU4NC00Ny41MjFhNy42MDQgNy42MDQgMCAxIDAtMTMuMTUzLTcuNjM0bC0zNC4yMTIgNTguOTRhNy42MDMgNy42MDMgMCAwIDAgLjY1IDguNTgxbDI0OC4zOTYgMzA5LjAwNGMuMTg4LjIzMy4zODguNDUyLjU5OS42NTkuMDE3LjAxNy4wMzguMDMxLjA1Ni4wNDlhNy41NTQgNy41NTQgMCAwIDAgLjk2OS43ODNjLjI0NS4xNjkuNDk5LjMyMy43NjIuNDYyLjA1Mi4wMjcuMTAxLjA1OC4xNTMuMDg0LjMyMS4xNi42NTMuMjk2Ljk5NC40MS4wNS4wMTYuMS4wMjguMTUuMDQ0LjMuMDkyLjYwNi4xNjUuOTE5LjIyMS4wNzIuMDEzLjE0My4wMjYuMjE1LjAzNi4zNjYuMDU0LjczNS4wOTEgMS4xMDkuMDkxLjM3NyAwIC43NDctLjAzOCAxLjExNS0uMDkyLjA2NC0uMDA5LjEyNy0uMDIxLjE5LS4wMzIuMzI4LS4wNTguNjUzLS4xMzQuOTY5LS4yMzMuMDMzLS4wMS4wNjgtLjAxOC4xMDEtLjAyOWE3LjczMSA3LjczMSAwIDAgMCAxLjAzMS0uNDI1Yy4wMjUtLjAxMy4wNS0uMDI4LjA3NC0uMDQyLjI5Ny0uMTUzLjU4My0uMzI4Ljg1OC0uNTIuMDQ5LS4wMzQuMDk3LS4wNjcuMTQ1LS4xMDJhNy42MSA3LjYxIDAgMCAwIDEuNDQ0LTEuMzY1bDI0OC4zOTYtMzA5LjAwNGE3LjYgNy42IDAgMCAwIC42NDktOC41OHptLTE5Ljc3OC0zLjc4NGgtNDIuNDc2YTcuNjA1IDcuNjA1IDAgMCAwIDAgMTUuMjA4aDM5LjgwN0wyNzcuMTQ3IDQ1My43OTVsODkuNzE5LTI2Mi45NTNoNDYuMzY2YTcuNjA1IDcuNjA1IDAgMCAwIDAtMTUuMjA4aC00NS42bC0zMC4zNDMtMTQ4LjI3aDY3Ljg1M2w4Ni4wNTEgMTQ4LjI3MXptLTM0Ni4wNjUgMTUuMjA4bDg5LjcxNSAyNjIuOTQxTDIzLjQ3NCAxOTAuODQzaDEyMS42NTR6bTE2LjA2OCAwaDE4OS41OTlsLTk0Ljc5OSAyNzcuODQ1LTk0LjgtMjc3Ljg0NXptMjkuMDMxLTE2My40NzloMTMxLjUzN2wzMC4zNDMgMTQ4LjI3SDE1OS44ODRsMzAuMzQzLTE0OC4yN3oiLz48L3N2Zz4="

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkZDMTA3O30NCjwvc3R5bGU+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMzk4LjcsMTk1LjZIMjgwLjlsMTguNS0xNTYuNGMwLTAuNCwwLjEtMiwwLjEtMi4zYzAtMTEuMS04LjctMTkuOC0xOS44LTE5LjhjLTYuMiwwLTEyLjIsMy0xNi4yLDguNA0KCUwxMDUsMjYzLjFjLTIuNiwzLjQtNCw3LjYtNCwxMS45YzAsMTEuMSw4LjcsMTkuOCwxOS44LDE5LjhIMjE5bC0xOC43LDE3Ni42YzAsMC4zLTAuMSwxLjctMC4xLDJjMCwxMS4xLDguNywxOS44LDE5LjgsMTkuOA0KCWM2LjIsMCwxMi4yLTMsMTYuMS04LjNsMTc4LjQtMjU3LjdjMi42LTMuNCw0LTcuNiw0LTExLjlDNDE4LjYsMjA0LjMsNDA5LjgsMTk1LjYsMzk4LjcsMTk1LjZ6Ii8+DQo8cGF0aCBkPSJNMjEzLDUxMmMtMTQuNywwLTI2LjctMTItMjYuNy0yNi43YzAtMC42LDAtMi4yLDAuMS0yLjhsMTkuNS0xODMuOWgtOTQuMkM5NywyOTguNyw4NSwyODYuNyw4NSwyNzJjMC01LjgsMS45LTExLjUsNS40LTE2DQoJTDI1NS4yLDExLjNDMjYwLjcsNCwyNjguNiwwLDI3NywwYzE0LjcsMCwyNi43LDEyLDI2LjcsMjYuN2MwLDAuNiwwLDIuNS0wLjEsMy4yTDI4NC4zLDE5MmgxMTUuM2MxNC43LDAsMjYuNywxMiwyNi43LDI2LjcNCgljMCw1LjctMS45LDExLjQtNS4zLDE2TDIzNC42LDUwMC45QzIyOS4zLDUwOCwyMjEuNCw1MTIsMjEzLDUxMnogTTEyMS43LDI2Ni43aDEwMmM0LjUsMCw4LjksMS45LDExLjksNS4zYzMsMy40LDQuNSw3LjksNCwxMi40DQoJbC0xOS4yLDE4MS4xbDE2OS0yNDEuNEgyNjYuM2MtNC42LDAtOC45LTItMTItNS40Yy0zLjEtMy40LTQuNS04LTMuOS0xMi41bDE4LjgtMTU4LjNMMTIxLjcsMjY2Ljd6IE0xMTYuNSwyNzQuNGwtMC4xLDAuMQ0KCUMxMTYuNCwyNzQuNSwxMTYuNSwyNzQuNSwxMTYuNSwyNzQuNHogTTM5OS43LDIyNGgwLjJIMzk5Ljd6IE0zOTUuMSwyMTUuOWMwLDAtMC4xLDAuMS0wLjEsMC4yTDM5NS4xLDIxNS45eiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userContent__ = __webpack_require__(739);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'headerTop',
  components: {
    userContent: __WEBPACK_IMPORTED_MODULE_0__userContent__["a" /* default */]
  },
  computed: {
    user: function user() {
      return this.$store.getters['student/GET'];
    }
  }
});

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),

/***/ 729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(665);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["a" /* default */]
  },
  name: 'buttonComponent',
  data: function data() {
    return {
      slickOptions: {
        slidesToShow: 10,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        speed: 300,
        responsive: [{
          breakpoint: 1000,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 7
          }
        }, {
          breakpoint: 820,
          settings: {
            slidesToScroll: 6,
            slidesToShow: 6
          }
        }, {
          breakpoint: 700,
          settings: {
            slidesToScroll: 5,
            slidesToShow: 5
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        }]
      },
      conquistas: [{
        id: 1,
        name: 'Diamond',
        image: 'diamond',
        color: '#FF9900',
        have: false
      }, {
        id: 2,
        name: 'Baloon',
        image: 'text',
        color: '#0EB7BF',
        have: false
      }, {
        id: 3,
        name: 'Search',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 4,
        name: 'Clock',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 5,
        name: 'Paint',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 6,
        name: 'Rule',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 7,
        name: 'Magic',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 8,
        name: 'Computer',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 9,
        name: 'Money',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 10,
        name: 'Disk',
        image: 'star',
        color: '#ff4455',
        have: false
      }]
    };
  }
});

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca5f500_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(737);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ca5f500"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca5f500_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(736);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("5a0cf69f", content, true, {});

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".container--percentage[data-v-3ca5f500]{width:100%;background:#d8d8d8;margin-bottom:20px;height:10px;overflow:hidden;border-radius:20px}.container--percentage .container--percentage--block[data-v-3ca5f500]{overflow:hidden}.container--percentage .container--percentage--block .container--percentage--block-anima[data-v-3ca5f500]{background:#255f83;background:-webkit-gradient(linear,right top,left bottom,from(#276c8c),to(#0ba6b2));background:linear-gradient(top right,#276c8c,#0ba6b2);-webkit-animation-name:animaPercentage-data-v-3ca5f500;animation-name:animaPercentage-data-v-3ca5f500;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-delay:2s;animation-delay:2s;height:10px;-webkit-animation-fill-mode:backwards;animation-fill-mode:backwards}@-webkit-keyframes animaPercentage-data-v-3ca5f500{0%{width:0}to{width:100%}}@keyframes animaPercentage-data-v-3ca5f500{0%{width:0}to{width:100%}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/metaPercentage/index.vue"],"names":[],"mappings":"AACA,wCACE,WAAY,AACZ,mBAAoB,AACpB,mBAAoB,AACpB,YAAa,AACb,gBAAiB,AACjB,kBAAoB,CACrB,AACD,sEACI,eAAiB,CACpB,AACD,0GACM,mBAAoB,AACpB,oFAAyF,AACzF,sDAAyD,AACzD,uDAAwD,AACxD,+CAAgD,AAChD,+BAAiC,AACjC,uBAAyB,AACzB,2BAA4B,AAC5B,mBAAoB,AACpB,YAAa,AACb,sCAAuC,AACvC,6BAA+B,CACpC,AACD,mDACA,GACI,OAAS,CACZ,AACD,GACI,UAAY,CACf,CACA,AACD,2CACA,GACI,OAAS,CACZ,AACD,GACI,UAAY,CACf,CACA","file":"index.vue","sourcesContent":["\n.container--percentage[data-v-3ca5f500] {\n  width: 100%;\n  background: #D8D8D8;\n  margin-bottom: 20px;\n  height: 10px;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.container--percentage .container--percentage--block[data-v-3ca5f500] {\n    overflow: hidden;\n}\n.container--percentage .container--percentage--block .container--percentage--block-anima[data-v-3ca5f500] {\n      background: #255F83;\n      background: -webkit-gradient(linear, right top, left bottom, from(#276C8C), to(#0BA6B2));\n      background: linear-gradient(top right, #276C8C, #0BA6B2);\n      -webkit-animation-name: animaPercentage-data-v-3ca5f500;\n      animation-name: animaPercentage-data-v-3ca5f500;\n      -webkit-animation-duration: 0.5s;\n      animation-duration: 0.5s;\n      -webkit-animation-delay: 2s;\n      animation-delay: 2s;\n      height: 10px;\n      -webkit-animation-fill-mode: backwards;\n      animation-fill-mode: backwards;\n}\n@-webkit-keyframes animaPercentage-data-v-3ca5f500 {\nfrom {\n    width: 0;\n}\nto {\n    width: 100%;\n}\n}\n@keyframes animaPercentage-data-v-3ca5f500 {\nfrom {\n    width: 0;\n}\nto {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container--percentage",style:({ height: _vm.height + 'px', borderRadius: _vm.borderRadius + 'px'})},[_c('div',{staticClass:"container--percentage--block",style:({ width: _vm.percentage + '%', height: _vm.height + 'px', borderRadius: _vm.borderRadius + 'px' })},[_c('div',{staticClass:"container--percentage--block-anima",style:({ height: _vm.height + 'px' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userContent_vue__ = __webpack_require__(678);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906d47c6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userContent_vue__ = __webpack_require__(751);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-906d47c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906d47c6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("4ed7ad86", content, true, {});

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".user--content[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;width:250px;max-width:100%;height:35px;background:#fff;border-radius:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.user--content .user--content__photo[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;width:50px;min-width:50px;height:50px;background:#ddd;border:2px solid #fff;border-radius:50%;overflow:hidden;cursor:pointer}.user--content .user--content__photo .user[data-v-906d47c6]{width:100%}.user--content .user--content__photo .icon_config[data-v-906d47c6]{display:none}.user--content .user--content__name[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;font-size:14px;color:#515151;font-weight:300;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center}.user--content .user--content__config[data-v-906d47c6]{-webkit-transition:.3s;transition:.3s;width:50px;height:35px;background:#979797;border-radius:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.user--content .user--content__config:hover .config[data-v-906d47c6]{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.user--content .user--content__config .config[data-v-906d47c6]{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;width:25px;max-width:90%}@media screen and (max-width:800px){.user--content[data-v-906d47c6]{margin-left:5px;width:40px}.user--content .user--content__config[data-v-906d47c6],.user--content .user--content__name[data-v-906d47c6]{display:none}.user--content .user--content__photo[data-v-906d47c6]{background:#73001c;width:40px;min-width:40px;max-width:40px;border-radius:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:none}.user--content .user--content__photo .icon_config[data-v-906d47c6]{display:inline}.user--content .user--content__photo .icon_photo[data-v-906d47c6]{display:none}.user--content .user--content__photo .config[data-v-906d47c6]{width:25px;margin:5px}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/header/userContent.vue"],"names":[],"mappings":"AACA,gCACE,uBAAyB,AACzB,eAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,YAAa,AACb,gBAAiB,AACjB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,sDACI,uBAAyB,AACzB,eAAiB,AACjB,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,gBAAiB,AACjB,sBAAuB,AACvB,kBAAmB,AACnB,gBAAiB,AACjB,cAAgB,CACnB,AACD,4DACM,UAAY,CACjB,AACD,mEACM,YAAc,CACnB,AACD,qDACI,uBAAyB,AACzB,eAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,gBAAiB,AACjB,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,iBAAmB,CACtB,AACD,uDAEI,uBAAyB,AACzB,eAAiB,AACjB,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACnB,AACD,qEACM,gCAAiC,AACzB,uBAAyB,CACtC,AACD,+DACM,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,+CAAiD,AACjD,WAAY,AACZ,aAAe,CACpB,AACD,oCACA,gCACI,gBAAiB,AACjB,UAAY,CACf,AACD,4GAEM,YAAc,CACnB,AACD,sDACM,mBAAoB,AACpB,WAAY,AACZ,eAAgB,AAChB,eAAgB,AAChB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAa,CAClB,AACD,mEACQ,cAAgB,CACvB,AACD,kEACQ,YAAc,CACrB,AACD,8DACQ,WAAY,AACZ,UAAY,CACnB,CACA","file":"userContent.vue","sourcesContent":["\n.user--content[data-v-906d47c6] {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  width: 250px;\n  max-width: 100%;\n  height: 35px;\n  background: #fff;\n  border-radius: 50px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.user--content .user--content__photo[data-v-906d47c6] {\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    width: 50px;\n    min-width: 50px;\n    height: 50px;\n    background: #ddd;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    overflow: hidden;\n    cursor: pointer;\n}\n.user--content .user--content__photo .user[data-v-906d47c6] {\n      width: 100%;\n}\n.user--content .user--content__photo .icon_config[data-v-906d47c6] {\n      display: none;\n}\n.user--content .user--content__name[data-v-906d47c6] {\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    font-size: 14px;\n    color: #515151;\n    font-weight: 300;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    text-align: center;\n}\n.user--content .user--content__config[data-v-906d47c6] {\n    cursor: pointer;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    width: 50px;\n    height: 35px;\n    background: #979797;\n    border-radius: 50px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    cursor: pointer;\n}\n.user--content .user--content__config:hover .config[data-v-906d47c6] {\n      -webkit-transform: rotate(90deg);\n              transform: rotate(90deg);\n}\n.user--content .user--content__config .config[data-v-906d47c6] {\n      -webkit-transition: -webkit-transform .2s;\n      transition: -webkit-transform .2s;\n      transition: transform .2s;\n      transition: transform .2s, -webkit-transform .2s;\n      width: 25px;\n      max-width: 90%;\n}\n@media screen and (max-width: 800px) {\n.user--content[data-v-906d47c6] {\n    margin-left: 5px;\n    width: 40px;\n}\n.user--content .user--content__config[data-v-906d47c6],\n    .user--content .user--content__name[data-v-906d47c6] {\n      display: none;\n}\n.user--content .user--content__photo[data-v-906d47c6] {\n      background: #73001c;\n      width: 40px;\n      min-width: 40px;\n      max-width: 40px;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      border: none;\n}\n.user--content .user--content__photo .icon_config[data-v-906d47c6] {\n        display: inline;\n}\n.user--content .user--content__photo .icon_photo[data-v-906d47c6] {\n        display: none;\n}\n.user--content .user--content__photo .config[data-v-906d47c6] {\n        width: 25px;\n        margin: 5px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"user--content"},[_c('div',{staticClass:"user--content__photo",on:{"click":function($event){return _vm.showMenu()}}},[_c('img',{staticClass:"icon_photo user",attrs:{"src":__webpack_require__(669),"alt":"Perfil"}}),_vm._v(" "),_c('img',{staticClass:"icon_config config",attrs:{"src":__webpack_require__(670),"alt":"Configuration"}})]),_vm._v(" "),_c('div',{staticClass:"user--content__name"},[_vm._v("\r\n      "+_vm._s(_vm.user.name)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"user--content__config",on:{"click":function($event){return _vm.showMenu()}}},[_c('img',{staticClass:"config",attrs:{"src":__webpack_require__(671),"alt":"Minds"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(769);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("119b19e8", content, true, {});

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, "footer[data-v-31e9ed4e]{background-image:-webkit-gradient(linear,left top,left bottom,color-stop(60%,#c50737),to(#cd1f26));background-image:linear-gradient(-180deg,#c50737 60%,#cd1f26)}.footer[data-v-31e9ed4e]{width:980px;max-width:100%;margin:0 auto;min-height:150px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#ff9aa6;padding-top:20px;padding-bottom:20px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:14px}.footer a[data-v-31e9ed4e],.footer router-link[data-v-31e9ed4e]{color:#ff9aa6;font-weight:700;-webkit-transition:.1s;transition:.1s;font-size:14px}.footer a[data-v-31e9ed4e]:hover,.footer router-link[data-v-31e9ed4e]:hover{color:#fff}.footer .footer--link .footer--link-ul[data-v-31e9ed4e]{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.footer .footer--link .footer--link-ul li[data-v-31e9ed4e]{margin-right:10px;margin-top:3px;margin-bottom:3px}.footer .footer--rights[data-v-31e9ed4e]{text-align:right}@media screen and (max-width:980px){.footer--link[data-v-31e9ed4e]{margin-left:20px}.footer--rights[data-v-31e9ed4e]{margin-right:20px}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/footer/index.vue"],"names":[],"mappings":"AACA,wBACE,mGAAyG,AACzG,6DAAiE,CAClE,AACD,yBACE,YAAa,AACb,eAAgB,AAChB,cAAe,AACf,iBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAe,AACf,iBAAkB,AAClB,oBAAqB,AACrB,8BAA+B,AACvB,sBAAuB,AAC/B,cAAgB,CACjB,AACD,gEAEI,cAAe,AACf,gBAAkB,AAClB,uBAAyB,AACzB,eAAiB,AACjB,cAAgB,CACnB,AACD,4EAEM,UAAY,CACjB,AACD,wDACI,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,eAAgB,AACpB,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACvC,AACD,2DACM,kBAAmB,AACnB,eAAgB,AAChB,iBAAmB,CACxB,AACD,yCACI,gBAAkB,CACrB,AACD,oCACA,+BACI,gBAAkB,CACrB,AACD,iCACI,iBAAmB,CACtB,CACA","file":"index.vue","sourcesContent":["\nfooter[data-v-31e9ed4e] {\n  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(60%, #C50737), to(#CD1F26));\n  background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);\n}\n.footer[data-v-31e9ed4e] {\n  width: 980px;\n  max-width: 100%;\n  margin: 0 auto;\n  min-height: 150px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #FF9AA6;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 14px;\n}\n.footer a[data-v-31e9ed4e],\n  .footer router-link[data-v-31e9ed4e] {\n    color: #FF9AA6;\n    font-weight: bold;\n    -webkit-transition: 0.1s;\n    transition: 0.1s;\n    font-size: 14px;\n}\n.footer a[data-v-31e9ed4e]:hover,\n    .footer router-link[data-v-31e9ed4e]:hover {\n      color: #fff;\n}\n.footer .footer--link .footer--link-ul[data-v-31e9ed4e] {\n    list-style: none;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.footer .footer--link .footer--link-ul li[data-v-31e9ed4e] {\n      margin-right: 10px;\n      margin-top: 3px;\n      margin-bottom: 3px;\n}\n.footer .footer--rights[data-v-31e9ed4e] {\n    text-align: right;\n}\n@media screen and (max-width: 980px) {\n.footer--link[data-v-31e9ed4e] {\n    margin-left: 20px;\n}\n.footer--rights[data-v-31e9ed4e] {\n    margin-right: 20px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"hidden"},[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer--link"},[_c('ul',{staticClass:"footer--link-ul animation-left"},[_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Sobre")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Escolas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("A Minds")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Ajuda")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Normas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }}},[_vm._v("Politica de privacidade")])],1)])]),_vm._v(" "),_c('div',{staticClass:"footer--rights animation-right"},[_vm._v("\r\n        © "+_vm._s(_vm.year)+" Minds, Inc. Todos os direitos reservados.\r\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/initialClass.033bf05.mp4";

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_feed__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userProperties__ = __webpack_require__(890);
//
//
//
//
//
//
//
//
//
//

// import userMetrics from '@/components/metrics'



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    feed: __WEBPACK_IMPORTED_MODULE_0__components_feed__["a" /* default */],
    userProperties: __WEBPACK_IMPORTED_MODULE_1__components_userProperties__["a" /* default */]
  },
  data: function data() {
    return {
      user: {
        id: 1,
        name: 'Joao Augusto',
        class: 'Apprentice',
        level: 1,
        points: 799
      }
    };
  },

  computed: {
    student: function student() {
      return this.$store.getters['student/GET'];
    }
  }
});

/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_metaPercentage__ = __webpack_require__(734);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'buttonComponent',
  data: function data() {
    return {
      statusTeacher: true,
      contentPosition: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    'article': 'feed/current',
    'canNext': 'feed/canNext',
    'canBack': 'feed/canBack'
  }), {
    arrContent: function arrContent() {
      if (!this.article || !this.article.content) return [];
      var text = this.article.content;
      text = text.replace(/<ol>|<\/ol>/g, '');
      return text.split('<li>').filter(function (i) {
        return !!i;
      }).map(function (i) {
        return i.replace(/<\/li>/g, '');
      });
    },
    canNextContent: function canNextContent() {
      return this.contentPosition < this.arrContent.length - 1;
    },
    canBackContent: function canBackContent() {
      return this.contentPosition > 0;
    },
    content: function content() {
      return this.arrContent[this.contentPosition] || 'None';
    }
  }),
  components: {
    metaPercentage: __WEBPACK_IMPORTED_MODULE_2__components_metaPercentage__["a" /* default */]
  },
  methods: {
    prevItem: function prevItem() {
      if (this.canBack) {
        this.contentPosition = 0;
        this.$store.commit('feed/prevPosition');
      }
    },
    nextItem: function nextItem() {
      if (this.canNext) {
        this.contentPosition = 0;
        this.$store.commit('feed/nextPosition');
      }
    },
    nextContent: function nextContent() {
      if (this.canNextContent) {
        this.contentPosition++;
      }
    },
    prevContent: function prevContent() {
      if (this.canBackContent) {
        this.contentPosition--;
      }
    }
  }
});

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'unidades',
  data: function data() {
    return {
      totalPoints: 800
    };
  },

  props: {
    user: {
      type: Object
    }
  },
  methods: {
    getLevelName: function getLevelName(level) {
      switch (level) {
        case 1:
          return 'Apprentice';
          break;
        case 2:
          return 'Planner';
          break;
        case 3:
          return 'Browser';
          break;
        case 4:
          return 'Explorer';
          break;
        case 5:
          return 'Colonizer';
          break;
        case 6:
          return 'Knight';
          break;
        case 7:
          return 'Grand Duke';
          break;
        case 8:
          return 'Imperial Prince';
          break;
        case 9:
          return 'Emperor';
          break;
        default:
          return 'Apprentice';
      }
    },
    getTotal: function getTotal(level) {
      return parseInt(level) * 800;
    }
  },
  computed: {
    xp: function xp() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(parseFloat(this.$store.getters['student/GET'].xp));
    },
    score: function score() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(parseFloat(this.$store.getters['student/GET'].score));
    }
  }
});

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoaderModal',
  data: function data() {
    return {
      pdf: 'Initial Class Minds.pdf'
    };
  },

  computed: {
    show: function show() {
      return this.$store.getters['showPdf'];
    },
    pdfSrc: function pdfSrc() {
      if (!this.pdf) return '';

      return __webpack_require__(898)("./" + this.pdf);
    }
  },
  methods: {
    showPdf: function showPdf(pdf) {
      this.pdf = pdf;
    }
  },
  watch: {
    show: function show(val) {
      if (!val) this.pdf = '';
    }
  }
});

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(807);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("7a1f4b8e", content, true, {});

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".menu--relative[data-v-c85fbffc]{position:relative;width:100%;min-height:100px;margin-bottom:20px;z-index:125}@media (max-width:440px){.menu--relative[data-v-c85fbffc]{min-height:75px}}.menu--relative .menu--fixed[data-v-c85fbffc]{background-image:-webkit-gradient(linear,left top,left bottom,color-stop(60%,#c50737),to(#cd1f26));background-image:linear-gradient(-180deg,#c50737 60%,#cd1f26);-webkit-box-shadow:0 0 55px 0 rgba(0,0,0,.5);box-shadow:0 0 55px 0 rgba(0,0,0,.5);position:fixed;top:0;left:0;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;z-index:100}.menu--relative .menu--fixed .menu--container[data-v-c85fbffc]{color:#ff9aa6;min-height:100px;width:980px;max-width:90%;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.menu--relative .menu--fixed .menu--container a[data-v-c85fbffc],.menu--relative .menu--fixed .menu--container router-link[data-v-c85fbffc]{color:#ff9aa6;-webkit-transition:.1s;transition:.1s;font-size:14px}.menu--relative .menu--fixed .menu--container a[data-v-c85fbffc]:hover,.menu--relative .menu--fixed .menu--container router-link[data-v-c85fbffc]:hover{color:#fff}@media (max-width:440px){.menu--relative .menu--fixed .menu--container[data-v-c85fbffc]{min-height:150px;-ms-flex-wrap:wrap;flex-wrap:wrap}}.menu--relative .menu--fixed .menu--container .menu--container__logo .logo[data-v-c85fbffc]{max-width:100%;min-width:80px}@media (max-width:440px){.menu--relative .menu--fixed .menu--container .menu--container__logo[data-v-c85fbffc]{min-width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:20px}}.menu--relative .menu--fixed .menu--container .menu--container__links[data-v-c85fbffc]{-webkit-transition:.3s;transition:.3s}.menu--relative .menu--fixed .menu--container .menu--container__links ul[data-v-c85fbffc]{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-c85fbffc],.menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-c85fbffc]{background:#fff;color:#c2003c;padding:10px 35px;border-radius:50px;margin:10px;line-height:35px;height:35px;font-size:14px;font-weight:300;-webkit-transition:.1s;transition:.1s}.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-c85fbffc]:hover,.menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-c85fbffc]:hover{color:#fff;background:#fbc024}.menu--relative .menu--fixed .menu--container .menu--container__icons[data-v-c85fbffc]{display:none}.menu--relative .menu--fixed .menu--container .menu--container__icons ul[data-v-c85fbffc]{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (max-width:440px){.menu--relative .menu--fixed .menu--container .menu--container__icons ul[data-v-c85fbffc]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}}.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-c85fbffc],.menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-c85fbffc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;color:#c2003c;padding:10px;border-radius:50px;margin:5px;line-height:35px;height:35px;-webkit-transition:.1s;transition:.1s}.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-c85fbffc]:hover,.menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-c85fbffc]:hover{color:#fff;background:#ff4600}@media (max-width:440px){.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-c85fbffc],.menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-c85fbffc]{padding:25px 20px;border-radius:10px;background:#970428}}.menu--relative .menu--fixed .menu--container .menu--container__icons ul li .fa[data-v-c85fbffc]{font-size:16px}@media (max-width:440px){.menu--relative .menu--fixed .menu--container .menu--container__icons[data-v-c85fbffc]{min-width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.example[data-v-c85fbffc]{background:#00acc2;border-radius:4px;padding-top:0}@media screen and (max-width:1200px){.menu--container__links[data-v-c85fbffc]{display:none}.menu--container__icons[data-v-c85fbffc]{display:block!important}}@media (max-width:440px){.animation-top[data-v-c85fbffc]{min-width:100%}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/header/index.vue"],"names":[],"mappings":"AACA,iCACE,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,mBAAoB,AACpB,WAAa,CACd,AACD,yBACA,iCACM,eAAiB,CACtB,CACA,AACD,8CACI,mGAAyG,AACzG,8DAAiE,AACjE,6CAAkD,AAC1C,qCAA0C,AAClD,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,8BAA+B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,WAAa,CAChB,AACD,+DACM,cAAe,AACf,iBAAkB,AAClB,YAAa,AACb,cAAe,AACf,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,4IAEQ,cAAe,AACf,uBAAyB,AACzB,eAAiB,AACjB,cAAgB,CACvB,AACD,wJAEU,UAAY,CACrB,AACD,yBACA,+DACU,iBAAkB,AAClB,mBAAoB,AAChB,cAAgB,CAC7B,CACA,AACD,4FACQ,eAAgB,AAChB,cAAgB,CACvB,AACD,yBACA,sFACU,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,eAAiB,CAC1B,CACA,AACD,uFACQ,uBAAyB,AACzB,cAAiB,CACxB,AACD,0FACU,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,wMAEY,gBAAoB,AACpB,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,uBAAyB,AACzB,cAAiB,CAC5B,AACD,oNAEc,WAAY,AACZ,kBAAoB,CACjC,AACD,uFACQ,YAAc,CACrB,AACD,0FACU,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,yBACA,0FACc,8BAA+B,AAC3B,2BAA4B,AACxB,4BAA8B,CACnD,CACA,AACD,wMAEY,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAoB,AACpB,cAAe,AACf,aAAc,AACd,mBAAoB,AACpB,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,uBAAyB,AACzB,cAAiB,CAC5B,AACD,oNAEc,WAAY,AACZ,kBAAoB,CACjC,AACD,yBACA,wMAEgB,kBAAmB,AACnB,mBAAoB,AACpB,kBAAoB,CACnC,CACA,AACD,iGACY,cAAgB,CAC3B,AACD,yBACA,uFACY,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAC3C,CACA,AACD,0BACE,mBAAoB,AACpB,kBAAmB,AACnB,aAAe,CAChB,AACD,qCACA,yCACI,YAAc,CACjB,AACD,yCACI,uBAA0B,CAC7B,CACA,AACD,yBACA,gCACI,cAAgB,CACnB,CACA","file":"index.vue","sourcesContent":["\n.menu--relative[data-v-c85fbffc] {\n  position: relative;\n  width: 100%;\n  min-height: 100px;\n  margin-bottom: 20px;\n  z-index: 125;\n}\n@media (max-width: 440px) {\n.menu--relative[data-v-c85fbffc] {\n      min-height: 75px;\n}\n}\n.menu--relative .menu--fixed[data-v-c85fbffc] {\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(60%, #C50737), to(#CD1F26));\n    background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);\n    -webkit-box-shadow: 0 0 55px 0 rgba(0, 0, 0, 0.5);\n            box-shadow: 0 0 55px 0 rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n    z-index: 100;\n}\n.menu--relative .menu--fixed .menu--container[data-v-c85fbffc] {\n      color: #FF9AA6;\n      min-height: 100px;\n      width: 980px;\n      max-width: 90%;\n      margin: 0 auto;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.menu--relative .menu--fixed .menu--container a[data-v-c85fbffc],\n      .menu--relative .menu--fixed .menu--container router-link[data-v-c85fbffc] {\n        color: #FF9AA6;\n        -webkit-transition: 0.1s;\n        transition: 0.1s;\n        font-size: 14px;\n}\n.menu--relative .menu--fixed .menu--container a[data-v-c85fbffc]:hover,\n        .menu--relative .menu--fixed .menu--container router-link[data-v-c85fbffc]:hover {\n          color: #fff;\n}\n@media (max-width: 440px) {\n.menu--relative .menu--fixed .menu--container[data-v-c85fbffc] {\n          min-height: 150px;\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n}\n}\n.menu--relative .menu--fixed .menu--container .menu--container__logo .logo[data-v-c85fbffc] {\n        max-width: 100%;\n        min-width: 80px;\n}\n@media (max-width: 440px) {\n.menu--relative .menu--fixed .menu--container .menu--container__logo[data-v-c85fbffc] {\n          min-width: 100%;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          margin-top: 20px;\n}\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links[data-v-c85fbffc] {\n        -webkit-transition: 0.3s;\n        transition: 0.3s;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links ul[data-v-c85fbffc] {\n          list-style: none;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-c85fbffc],\n          .menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-c85fbffc] {\n            background: #ffffff;\n            color: #C2003C;\n            padding: 10px 35px;\n            border-radius: 50px;\n            margin: 10px;\n            line-height: 35px;\n            height: 35px;\n            font-size: 14px;\n            font-weight: 300;\n            -webkit-transition: 0.1s;\n            transition: 0.1s;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__links ul li a[data-v-c85fbffc]:hover,\n            .menu--relative .menu--fixed .menu--container .menu--container__links ul li router-link[data-v-c85fbffc]:hover {\n              color: #fff;\n              background: #FBC024;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons[data-v-c85fbffc] {\n        display: none;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul[data-v-c85fbffc] {\n          list-style: none;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n@media (max-width: 440px) {\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul[data-v-c85fbffc] {\n              -webkit-box-pack: space-evenly;\n                  -ms-flex-pack: space-evenly;\n                      justify-content: space-evenly;\n}\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-c85fbffc],\n          .menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-c85fbffc] {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                    justify-content: center;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n            background: #ffffff;\n            color: #C2003C;\n            padding: 10px;\n            border-radius: 50px;\n            margin: 5px;\n            line-height: 35px;\n            height: 35px;\n            -webkit-transition: 0.1s;\n            transition: 0.1s;\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-c85fbffc]:hover,\n            .menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-c85fbffc]:hover {\n              color: #fff;\n              background: #ff4600;\n}\n@media (max-width: 440px) {\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul li a[data-v-c85fbffc],\n              .menu--relative .menu--fixed .menu--container .menu--container__icons ul li router-link[data-v-c85fbffc] {\n                padding: 25px 20px;\n                border-radius: 10px;\n                background: #970428;\n}\n}\n.menu--relative .menu--fixed .menu--container .menu--container__icons ul li .fa[data-v-c85fbffc] {\n            font-size: 16px;\n}\n@media (max-width: 440px) {\n.menu--relative .menu--fixed .menu--container .menu--container__icons[data-v-c85fbffc] {\n            min-width: 100%;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                    justify-content: center;\n}\n}\n.example[data-v-c85fbffc] {\n  background: #00ACC2;\n  border-radius: 4px;\n  padding-top: 0;\n}\n@media screen and (max-width: 1200px) {\n.menu--container__links[data-v-c85fbffc] {\n    display: none;\n}\n.menu--container__icons[data-v-c85fbffc] {\n    display: block !important;\n}\n}\n@media (max-width: 440px) {\n.animation-top[data-v-c85fbffc] {\n    min-width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 808:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu--relative"},[_c('div',{staticClass:"menu--fixed hidden"},[_c('div',{staticClass:"menu--container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu--container__links"},[_c('ul',{staticClass:"animation-top"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("HOME")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'books' }}},[_vm._v("BOOKS")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'store' }}},[_vm._v("STORE")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'palavras' }}},[_vm._v("WORDS")])],1),_vm._v(" "),_c('li',[_c('userContent',{staticClass:"animation-right",attrs:{"data":_vm.user}})],1)])]),_vm._v(" "),_c('div',{staticClass:"menu--container__icons"},[_c('ul',{staticClass:"animation-top"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":__webpack_require__(682),"width":"25px","alt":"Minds"}})])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'books' }}},[_c('img',{attrs:{"src":__webpack_require__(683),"width":"25px","alt":"Minds"}})])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'store' }}},[_c('img',{attrs:{"src":__webpack_require__(684),"width":"25px","alt":"Minds"}})])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'palavras' }}},[_c('img',{attrs:{"src":__webpack_require__(685),"width":"25px","alt":"Minds"}})])],1),_vm._v(" "),_c('li',[_c('userContent',{staticClass:"animation-right",attrs:{"data":_vm.user}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu--container__logo animation-left"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(662),"width":"137","alt":"Minds"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(818);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("5f25f230", content, true, {});

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports
exports.i(__webpack_require__(819), "");
exports.i(__webpack_require__(820), "");

// module
exports.push([module.i, ".slick-side[data-v-abed402e]{outline:none!important}.slick-prev[data-v-abed402e]{left:0!important;z-index:10}.slick-next[data-v-abed402e]{right:0!important;z-index:10}.slick-next[data-v-abed402e]:before,.slick-prev[data-v-abed402e]:before{color:#bababa!important}.conquistas--block-icons .slick-prev[data-v-abed402e]{left:-25!important}.conquistas--block-icons .slick-next[data-v-abed402e]{right:-25!important}.slick-track[data-v-abed402e]{display:-webkit-box;display:-ms-flexbox;display:flex}.conquistas--block[data-v-abed402e]{background:#f3f3f3;height:50px;-webkit-box-sizing:border-box;box-sizing:border-box;padding:5px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-shadow:10px 22px 40px 0 rgba(0,0,0,.19),0 8px 8px 0 rgba(0,0,0,.09);box-shadow:10px 22px 40px 0 rgba(0,0,0,.19),0 8px 8px 0 rgba(0,0,0,.09);width:790px;margin:0 auto;margin-bottom:20px}.conquistas--block .conquistas--block-icons[data-v-abed402e],.conquistas--block[data-v-abed402e]{border-radius:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;max-width:100%;overflow:hidden;position:relative}.conquistas--block .conquistas--block-icons[data-v-abed402e]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:730px;margin:0 auto;height:calc(100% + 10px);margin-left:0!important;margin-right:0!important}.conquistas--block .conquistas--block-icons[data-v-abed402e]::-webkit-scrollbar{width:5px;height:5px}.conquistas--block .conquistas--block-icons[data-v-abed402e]::-webkit-scrollbar-track{-webkit-box-shadow:none;background:transparent}.conquistas--block .conquistas--block-icons[data-v-abed402e]::-webkit-scrollbar-thumb{background:#ddd;border-radius:20px}.conquistas--block .conquistas--block-icons-box[data-v-abed402e]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;width:35px;height:35px;max-width:35px;border-radius:50%;background:#ddd;margin-left:11px;margin-right:11px;cursor:pointer}.conquistas--block .conquistas--block-icons-box[data-v-abed402e],.conquistas--block .conquistas--block-icons-box img[data-v-abed402e]{-webkit-transition:.1s;transition:.1s;-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-perspective:100;perspective:1000}.conquistas--block .conquistas--block-icons-box img[data-v-abed402e]{width:24px;height:24px}.conquistas--block .conquistas--block-icons-box[data-v-abed402e]:hover{-webkit-transform:scale(1.1);transform:scale(1.1);-webkit-box-shadow:10px 60px 40px 0 rgba(0,0,0,.19),0 8px 8px 0 rgba(0,0,0,.09);box-shadow:10px 60px 40px 0 rgba(0,0,0,.19),0 8px 8px 0 rgba(0,0,0,.09)}@media screen and (max-width:1200px){.conquistas--block-icons[data-v-abed402e]{margin-left:35px!important;margin-right:30px!important}}.block[data-v-abed402e]{background:#aaa!important;cursor:not-allowed!important}.block img[data-v-abed402e]{-webkit-filter:grayscale(100%);filter:grayscale(100%)}.block[data-v-abed402e]:hover{-webkit-transform:none!important;transform:none!important}.conquistas--block-button[data-v-abed402e]{background:#d5d5d5;border-radius:50px;color:#606060;width:122px;padding-left:5px;padding-right:5px;height:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:5px}.conquistas--block-button h3[data-v-abed402e]{font-size:13px!important;line-height:12px!important}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/achievements/index.vue"],"names":[],"mappings":"AAGA,6BACE,sBAAyB,CAC1B,AACD,6BACE,iBAAmB,AACnB,UAAY,CACb,AACD,6BACE,kBAAoB,AACpB,UAAY,CACb,AACD,wEAEE,uBAA0B,CAC3B,AACD,sDACE,kBAAqB,CACtB,AACD,sDACE,mBAAsB,CACvB,AACD,8BACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,oCACE,mBAAoB,AAEpB,YAAa,AAIb,8BAA+B,AACvB,sBAAuB,AAC/B,YAAa,AACb,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AAIpC,gFAA0F,AAClF,wEAAkF,AAC1F,YAAa,AAEb,cAAe,AAGf,kBAAoB,CACrB,AACD,iGAvBE,mBAAoB,AAEpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAOd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAI5B,eAAgB,AAEhB,gBAAiB,AACjB,iBAAmB,CAsBpB,AAnBD,6DAOI,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AAEvC,YAAa,AAEb,cAAe,AACf,yBAA0B,AAG1B,wBAA0B,AAC1B,wBAA2B,CAC9B,AACD,gFACM,UAAW,AACX,UAAY,CACjB,AACD,sFACM,wBAAyB,AACzB,sBAAwB,CAC7B,AACD,sFACM,gBAAiB,AACjB,kBAAoB,CACzB,AACD,iEACI,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AAOnB,cAAgB,CACnB,AACD,sIARI,uBAAyB,AACzB,eAAiB,AACjB,oCAAqC,AAC7B,4BAA6B,AACrC,wBAAyB,AACzB,gBAAkB,CAYrB,AATD,qEACM,WAAY,AACZ,WAAa,CAOlB,AACD,uEACM,6BAAmC,AAC3B,qBAA2B,AACnC,gFAA0F,AAClF,uEAAkF,CAC/F,AACD,qCACA,0CACI,2BAA6B,AAC7B,2BAA8B,CACjC,CACA,AACD,wBACE,0BAA+B,AAC/B,4BAA+B,CAChC,AACD,4BACI,+BAAgC,AACxB,sBAAwB,CACnC,AACD,8BACI,iCAAmC,AAC3B,wBAA2B,CACtC,AACD,2CACE,mBAAoB,AACpB,mBAAoB,AACpB,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,eAAiB,CAClB,AACD,8CACI,yBAA2B,AAC3B,0BAA6B,CAChC","file":"index.vue","sourcesContent":["\n@import url(../../../node_modules/slick-carousel/slick/slick.css);\n@import url(../../../node_modules/slick-carousel/slick/slick-theme.css);\n.slick-side[data-v-abed402e] {\n  outline: none !important;\n}\n.slick-prev[data-v-abed402e] {\n  left: 0 !important;\n  z-index: 10;\n}\n.slick-next[data-v-abed402e] {\n  right: 0 !important;\n  z-index: 10;\n}\n.slick-next[data-v-abed402e]:before,\n.slick-prev[data-v-abed402e]:before {\n  color: #BABABA !important;\n}\n.conquistas--block-icons .slick-prev[data-v-abed402e] {\n  left: -25 !important;\n}\n.conquistas--block-icons .slick-next[data-v-abed402e] {\n  right: -25 !important;\n}\n.slick-track[data-v-abed402e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.conquistas--block[data-v-abed402e] {\n  background: #F3F3F3;\n  border-radius: 50px;\n  height: 50px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 5px;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-shadow: 10px 22px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);\n          box-shadow: 10px 22px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);\n  width: 790px;\n  max-width: 100%;\n  margin: 0 auto;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 20px;\n}\n.conquistas--block .conquistas--block-icons[data-v-abed402e] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    overflow: hidden;\n    width: 730px;\n    max-width: 100%;\n    margin: 0 auto;\n    height: calc(100% + 10px);\n    border-radius: 50px;\n    position: relative;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n.conquistas--block .conquistas--block-icons[data-v-abed402e]::-webkit-scrollbar {\n      width: 5px;\n      height: 5px;\n}\n.conquistas--block .conquistas--block-icons[data-v-abed402e]::-webkit-scrollbar-track {\n      -webkit-box-shadow: none;\n      background: transparent;\n}\n.conquistas--block .conquistas--block-icons[data-v-abed402e]::-webkit-scrollbar-thumb {\n      background: #ddd;\n      border-radius: 20px;\n}\n.conquistas--block .conquistas--block-icons-box[data-v-abed402e] {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n    width: 35px;\n    height: 35px;\n    max-width: 35px;\n    border-radius: 50%;\n    background: #ddd;\n    margin-left: 11px;\n    margin-right: 11px;\n    -webkit-transition: 0.1s;\n    transition: 0.1s;\n    -webkit-backface-visibility: visible;\n            backface-visibility: visible;\n    -webkit-perspective: 100;\n    perspective: 1000;\n    cursor: pointer;\n}\n.conquistas--block .conquistas--block-icons-box img[data-v-abed402e] {\n      width: 24px;\n      height: 24px;\n      -webkit-transition: 0.1s;\n      transition: 0.1s;\n      -webkit-backface-visibility: visible;\n              backface-visibility: visible;\n      -webkit-perspective: 100;\n      perspective: 1000;\n}\n.conquistas--block .conquistas--block-icons-box[data-v-abed402e]:hover {\n      -webkit-transform: scale(1.1, 1.1);\n              transform: scale(1.1, 1.1);\n      -webkit-box-shadow: 10px 60px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);\n              box-shadow: 10px 60px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);\n}\n@media screen and (max-width: 1200px) {\n.conquistas--block-icons[data-v-abed402e] {\n    margin-left: 35px !important;\n    margin-right: 30px !important;\n}\n}\n.block[data-v-abed402e] {\n  background: #AAAAAA !important;\n  cursor: not-allowed !important;\n}\n.block img[data-v-abed402e] {\n    -webkit-filter: grayscale(100%);\n            filter: grayscale(100%);\n}\n.block[data-v-abed402e]:hover {\n    -webkit-transform: none !important;\n            transform: none !important;\n}\n.conquistas--block-button[data-v-abed402e] {\n  background: #D5D5D5;\n  border-radius: 50px;\n  color: #606060;\n  width: 122px;\n  padding-left: 5px;\n  padding-right: 5px;\n  height: 35px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 5px;\n}\n.conquistas--block-button h3[data-v-abed402e] {\n    font-size: 13px !important;\n    line-height: 12px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list,.slick-slider{position:relative;display:block}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.slick-track{position:relative;top:0;left:0;display:block;margin-left:auto;margin-right:auto}.slick-track:after,.slick-track:before{display:table;content:\"\"}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/node_modules/slick-carousel/slick/slick.css"],"names":[],"mappings":"AACA,cAKI,sBAAuB,AAEvB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAE1B,2BAA4B,AAC5B,wBAAyB,AACzB,uBAAwB,AACpB,mBAAoB,AACxB,uCAAyC,CAC5C,AAED,0BAjBI,kBAAmB,AAEnB,aAAe,CAwBlB,AATD,YAKI,gBAAiB,AAEjB,SAAU,AACV,SAAW,CACd,AACD,kBAEI,YAAc,CACjB,AACD,qBAEI,eAAgB,AAChB,WAAa,CAChB,AAED,qDAGI,gCAAwC,AACrC,6BAAqC,AACpC,4BAAoC,AACnC,2BAAmC,AAChC,uBAAgC,CAC3C,AAED,aAEI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AAER,cAAe,AACf,iBAAkB,AAClB,iBAAmB,CACtB,AACD,uCAGI,cAAe,AAEf,UAAY,CACf,AACD,mBAEI,UAAY,CACf,AACD,4BAEI,iBAAmB,CACtB,AAED,aAEI,aAAc,AACd,WAAY,AAEZ,YAAa,AACb,cAAgB,CACnB,AACD,uBAEI,WAAa,CAChB,AACD,iBAEI,aAAe,CAClB,AACD,+BAEI,YAAc,CACjB,AACD,0BAEI,mBAAqB,CACxB,AACD,gCAEI,aAAe,CAClB,AACD,4BAEI,iBAAmB,CACtB,AACD,6BAEI,cAAe,AAEf,YAAa,AAEb,4BAA8B,CACjC,AACD,0BACI,YAAc,CACjB","file":"slick.css","sourcesContent":["/* Slider */\n.slick-slider\n{\n    position: relative;\n\n    display: block;\n    box-sizing: border-box;\n\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list\n{\n    position: relative;\n\n    display: block;\n    overflow: hidden;\n\n    margin: 0;\n    padding: 0;\n}\n.slick-list:focus\n{\n    outline: none;\n}\n.slick-list.dragging\n{\n    cursor: pointer;\n    cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list\n{\n    -webkit-transform: translate3d(0, 0, 0);\n       -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n         -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n\n.slick-track\n{\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.slick-track:before,\n.slick-track:after\n{\n    display: table;\n\n    content: '';\n}\n.slick-track:after\n{\n    clear: both;\n}\n.slick-loading .slick-track\n{\n    visibility: hidden;\n}\n\n.slick-slide\n{\n    display: none;\n    float: left;\n\n    height: 100%;\n    min-height: 1px;\n}\n[dir='rtl'] .slick-slide\n{\n    float: right;\n}\n.slick-slide img\n{\n    display: block;\n}\n.slick-slide.slick-loading img\n{\n    display: none;\n}\n.slick-slide.dragging img\n{\n    pointer-events: none;\n}\n.slick-initialized .slick-slide\n{\n    display: block;\n}\n.slick-loading .slick-slide\n{\n    visibility: hidden;\n}\n.slick-vertical .slick-slide\n{\n    display: block;\n\n    height: auto;\n\n    border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(569);
exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".slick-loading .slick-list{background:#fff url(" + escape(__webpack_require__(821)) + ") 50% no-repeat}@font-face{font-family:slick;font-weight:400;font-style:normal;src:url(" + escape(__webpack_require__(728)) + ");src:url(" + escape(__webpack_require__(728)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(822)) + ") format(\"woff\"),url(" + escape(__webpack_require__(823)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(824)) + "#slick) format(\"svg\")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:slick;font-size:20px;line-height:1;opacity:.75;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:\"\\2190\"}[dir=rtl] .slick-prev:before{content:\"\\2192\"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:\"\\2192\"}[dir=rtl] .slick-next:before{content:\"\\2190\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/node_modules/slick-carousel/slick/slick-theme.css"],"names":[],"mappings":"AAEA,2BAEI,2DAAkE,CACrE,AAGD,WAEI,kBAAqB,AACrB,gBAAoB,AACpB,kBAAmB,AAEnB,kCAA8B,AAC9B,uMAAsM,CACzM,AAED,wBAGI,YAAa,AACb,cAAe,AAEf,kBAAmB,AACnB,QAAS,AAET,cAAe,AAEf,WAAY,AACZ,YAAa,AACb,UAAW,AACX,mCAAsC,AACtC,+BAAkC,AAClC,2BAA8B,AAE9B,eAAgB,AAGhB,WAAa,CAGhB,AACD,gGALI,kBAAmB,AAEnB,aAAc,AACd,sBAAwB,CAU3B,AACD,oGAKI,SAAW,CACd,AACD,oEAGI,WAAa,CAChB,AAED,sCAGI,kBAAqB,AACrB,eAAgB,AAChB,cAAe,AAEf,YAAa,AACb,WAAa,AAEb,mCAAoC,AACpC,iCAAmC,CACtC,AAED,YAEI,UAAY,CACf,AACD,sBAEI,YAAa,AACb,SAAW,CACd,AACD,mBAEI,eAAa,CAChB,AACD,6BAEI,eAAa,CAChB,AAED,YAEI,WAAa,CAChB,AACD,sBAEI,WAAY,AACZ,UAAY,CACf,AACD,mBAEI,eAAa,CAChB,AACD,6BAEI,eAAa,CAChB,AAGD,2BAEI,kBAAoB,CACvB,AAED,YAEI,kBAAmB,AACnB,aAAc,AAEd,cAAe,AAEf,WAAY,AACZ,UAAW,AACX,SAAU,AAEV,gBAAiB,AAEjB,iBAAmB,CACtB,AACD,eAEI,kBAAmB,AAEnB,qBAAsB,AAItB,aAAc,AACd,SAAW,CAGd,AACD,qCAPI,WAAY,AACZ,YAAa,AAIb,cAAgB,CAmBnB,AAjBD,sBAEI,YAAa,AACb,cAAe,AAEf,cAAe,AAIf,YAAa,AAIb,kBAAmB,AACnB,SAAU,AACV,aAAc,AACd,sBAAwB,CAC3B,AACD,wDAGI,YAAc,CACjB,AACD,sEAGI,SAAW,CACd,AACD,6BAEI,kBAAqB,AACrB,cAAe,AACf,iBAAkB,AAElB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AAER,WAAY,AACZ,YAAa,AAEb,gBAAa,AACb,kBAAmB,AAEnB,YAAa,AACb,WAAa,AAEb,mCAAoC,AACpC,iCAAmC,CACtC,AACD,0CAEI,YAAa,AACb,UAAa,CAChB","file":"slick-theme.css","sourcesContent":["@charset 'UTF-8';\n/* Slider */\n.slick-loading .slick-list\n{\n    background: #fff url('./ajax-loader.gif') center center no-repeat;\n}\n\n/* Icons */\n@font-face\n{\n    font-family: 'slick';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('./fonts/slick.eot');\n    src: url('./fonts/slick.eot?#iefix') format('embedded-opentype'), url('./fonts/slick.woff') format('woff'), url('./fonts/slick.ttf') format('truetype'), url('./fonts/slick.svg#slick') format('svg');\n}\n/* Arrows */\n.slick-prev,\n.slick-next\n{\n    font-size: 0;\n    line-height: 0;\n\n    position: absolute;\n    top: 50%;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n\n    cursor: pointer;\n\n    color: transparent;\n    border: none;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover,\n.slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus\n{\n    color: transparent;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover:before,\n.slick-prev:focus:before,\n.slick-next:hover:before,\n.slick-next:focus:before\n{\n    opacity: 1;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before\n{\n    opacity: .25;\n}\n\n.slick-prev:before,\n.slick-next:before\n{\n    font-family: 'slick';\n    font-size: 20px;\n    line-height: 1;\n\n    opacity: .75;\n    color: white;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.slick-prev\n{\n    left: -25px;\n}\n[dir='rtl'] .slick-prev\n{\n    right: -25px;\n    left: auto;\n}\n.slick-prev:before\n{\n    content: '←';\n}\n[dir='rtl'] .slick-prev:before\n{\n    content: '→';\n}\n\n.slick-next\n{\n    right: -25px;\n}\n[dir='rtl'] .slick-next\n{\n    right: auto;\n    left: -25px;\n}\n.slick-next:before\n{\n    content: '→';\n}\n[dir='rtl'] .slick-next:before\n{\n    content: '←';\n}\n\n/* Dots */\n.slick-dotted.slick-slider\n{\n    margin-bottom: 30px;\n}\n\n.slick-dots\n{\n    position: absolute;\n    bottom: -25px;\n\n    display: block;\n\n    width: 100%;\n    padding: 0;\n    margin: 0;\n\n    list-style: none;\n\n    text-align: center;\n}\n.slick-dots li\n{\n    position: relative;\n\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n    margin: 0 5px;\n    padding: 0;\n\n    cursor: pointer;\n}\n.slick-dots li button\n{\n    font-size: 0;\n    line-height: 0;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 5px;\n\n    cursor: pointer;\n\n    color: transparent;\n    border: 0;\n    outline: none;\n    background: transparent;\n}\n.slick-dots li button:hover,\n.slick-dots li button:focus\n{\n    outline: none;\n}\n.slick-dots li button:hover:before,\n.slick-dots li button:focus:before\n{\n    opacity: 1;\n}\n.slick-dots li button:before\n{\n    font-family: 'slick';\n    font-size: 6px;\n    line-height: 20px;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 20px;\n    height: 20px;\n\n    content: '•';\n    text-align: center;\n\n    opacity: .25;\n    color: black;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button:before\n{\n    opacity: .75;\n    color: black;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 821:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

module.exports = "data:font/woff;base64,d09GRk9UVE8AAAVkAAsAAAAAB1wAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAABCAAAAi4AAAKbH/pWDkZGVE0AAAM4AAAAGgAAABxt0civR0RFRgAAA1QAAAAcAAAAIAAyAARPUy8yAAADcAAAAFIAAABgUBj/rmNtYXAAAAPEAAAAUAAAAWIiC0SwaGVhZAAABBQAAAAuAAAANgABMftoaGVhAAAERAAAABwAAAAkA+UCA2htdHgAAARgAAAADgAAAA4ESgBKbWF4cAAABHAAAAAGAAAABgAFUABuYW1lAAAEeAAAANwAAAFuBSeBwnBvc3QAAAVUAAAAEAAAACAAAwABeJw9ks9vEkEUx2cpWyeUoFYgNkHi2Wt7N3rVm3cTs3UVLC4LxIWEQvi1P3i7O1tYLJDAmlgKGEhQrsajf0j7J3jYTXrQWUrMJG+++b55n5e8NwwKBhHDMLv5kxT3ATEBxKBn3qOAl9zxHgb1MAPhHQgHkyF08Gr/L8B/Eb6zWnmCJ7AJVLubQOheArXvJ1A4EXi6j4I+Zg9F0QFKvsnlBCmXeve+sFEnb/nCptdtQ4QYhVFRAT1HrF8UQK/RL/SbmUbclsvGVFXRZKDHUE38cc4qpkbAAsuwiImvro+ufcfaOIQ6szlrmjRJDaKZKnbjN3GWKIbiIzRFUfCffuxxKOL+3LDlDVvx2TdxN84qZEsnhNBa6pgm2dAsnzbLsETdsmRFxUeHV4e+I2/ptN8TyqV8T3Dt29t7EYOuajVIw2y1Wy3M86w0zg/Fz2IvawmQAUHOVrPVfLkoScVynsqsTG0MGUs4z55nh3mnOJa+li+rl9WpPIcFfDubDeaDC+fLBdYN3QADzLauGfj4B6sZmq6CCpqmtSvF0qlUl2qf5AJIUCSlTqlb7lUG+LRfGzZGzZEyBgccMu6MuqPecNDvD4Y9Kjtj4gD+DsvKVMTcMdtqtZtmkzQstQvYje7Syep0PDSAhSOeHYXYWThEF//A/0YvYV1fSQtpKU5STtrhbQ444OtpKSWJIg3pOg8cBs7maTY1EZf07aq+hjWs7IWzdCYTGhb2CtZ47x+Uhx28AAB4nGNgYGBkAIJz765vANHnCyvqYTQAWnkHswAAeJxjYGRgYOADYgkGEGBiYARCFjAG8RgABHYAN3icY2BmYmCcwMDKwMHow5jGwMDgDqW/MkgytDAwMDGwcjKAQQMDAyOQUmCAgoA01xQGB4ZExUmMD/4/YNBjvP3/NgNEDQPjbbBKBQZGADfLDgsAAHicY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQzMCQqKClOUJz0/z9YHRLv/+L7D+8V3cuHmgAHjGwM6ELUByxUMIOZCmbgAAA5LQ8XeJxjYGRgYABiO68w73h+m68M3EwMIHC+sKIeTqsyqDLeZrwN5HIwgKUB/aYJUgAAeJxjYGRgYLzNwMCgx8QAAkA2IwMqYAIAMGIB7QIAAAACAAAlACUAJQAlAAAAAFAAAAUAAHicbY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV4nGNgZkAGjAxoAAAAjgAF"

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

module.exports = "data:font/ttf;base64,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"

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 825:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conquistas--block animation-top animation-delay-05"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"conquistas--block-icons"},[_c('slick',{ref:"slick",staticClass:"slick--unit__exercices",staticStyle:{"width":"100%!important"},attrs:{"options":_vm.slickOptions}},_vm._l((_vm.conquistas),function(x,key){return _c('div',{key:x.id},[_c('div',{staticClass:"conquistas--block-icons-box",class:{ block: !x.have},style:({background: x.color})},[_c('img',{attrs:{"src":__webpack_require__(826)("./" + x.id + '.svg'),"rel":"conquistas","alt":"Minds"}})])])}),0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conquistas--block-button"},[_c('span',{staticClass:"conquistas"},[_c('h3',[_vm._v("CONQUESTS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.svg": 686,
	"./10.svg": 687,
	"./2.svg": 688,
	"./3.svg": 689,
	"./4.svg": 666,
	"./5.svg": 690,
	"./6.svg": 691,
	"./7.svg": 692,
	"./8.svg": 693,
	"./9.svg": 694
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 826;

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/notification.d8d435a.mp3";

/***/ }),

/***/ 886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(798);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ece00a2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(889);
function injectStyle (ssrContext) {
  __webpack_require__(887)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ece00a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ece00a2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(888);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("17d71b69", content, true, {});

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".borda[data-v-0ece00a2]{border:1px solid #4169e1}.feed[data-v-0ece00a2]{height:409px!important}.feed-content[data-v-0ece00a2]{max-height:100%}.feed-content__title[data-v-0ece00a2]{cursor:pointer;-webkit-transition:.3s;transition:.3s;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;color:#255f83;font-size:14px}.feed-content__title span[data-v-0ece00a2]{font-weight:900;background:#1483a0;padding:5px 15px;border-radius:50px;color:#fff;font-weight:300}.feed hr[data-v-0ece00a2]{margin:15px 0;background:#dadada;border:none;padding:1px;border-radius:100px}.feed-box[data-v-0ece00a2]{border-radius:15px;padding:10px;border:1px solid #bfbfbf}.feed-box[data-v-0ece00a2],.feed-box_base[data-v-0ece00a2]{width:100%;height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.feed-box_base[data-v-0ece00a2]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.feed-box_base_etiqueta[data-v-0ece00a2]{width:100%}.feed-box_base_etiqueta_tipe[data-v-0ece00a2]{padding:5px 25px;border-radius:50px;color:#fff;font-weight:300;width:100%}.feed-box_base_etiqueta_tipe.blue[data-v-0ece00a2]{background:#0e9aaa}.feed-box_base_etiqueta_tipe.orange[data-v-0ece00a2]{background:orange}.feed-box_base_etiqueta_next[data-v-0ece00a2]{cursor:pointer;padding:5px 12px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;border-radius:50px;color:#fff;font-weight:300}.feed-box_base_etiqueta_next.blue[data-v-0ece00a2]{background:#0e9aaa}.feed-box_base_etiqueta_next.orange[data-v-0ece00a2]{background:#f60}.feed-box_base_etiqueta_next.disabled[data-v-0ece00a2]{color:#aaa}.feed-box_base_etiqueta_next.disabled[data-v-0ece00a2]:hover{cursor:not-allowed;background-color:#6f6f6f}.feed-box_base_etiqueta_next[data-v-0ece00a2]:hover{-webkit-filter:brightness(1.5);filter:brightness(1.5)}.feed-box_base_etiqueta_prev[data-v-0ece00a2]{cursor:pointer;padding:5px 12px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;border-radius:50px;color:#fff;font-weight:300;margin:0 5px}.feed-box_base_etiqueta_prev img[data-v-0ece00a2]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.feed-box_base_etiqueta_prev.blue[data-v-0ece00a2]{background:#0e9aaa}.feed-box_base_etiqueta_prev.orange[data-v-0ece00a2]{background:#f60}.feed-box_base_etiqueta_prev.disabled[data-v-0ece00a2]{color:#aaa}.feed-box_base_etiqueta_prev.disabled[data-v-0ece00a2]:hover{cursor:not-allowed;background-color:#6f6f6f}.feed-box_base_etiqueta_prev[data-v-0ece00a2]:hover{-webkit-filter:brightness(1.5);filter:brightness(1.5)}.feed-box_base_etiqueta_text[data-v-0ece00a2]{max-height:115px;min-height:115px;overflow-y:scroll;overflow-x:hidden;font-size:14px;font-weight:300;line-height:17px;padding:5px;margin:10px 0}.feed-box_base_etiqueta_text[data-v-0ece00a2]::-webkit-scrollbar{width:10px}.feed-box_base_etiqueta_text[data-v-0ece00a2]::-webkit-scrollbar-thumb{background:#666;border-radius:20px}.feed-box_base_etiqueta_text[data-v-0ece00a2]::-webkit-scrollbar-track{background:#ddd;border-radius:20px}.feed-box_base_etiqueta_text.article[data-v-0ece00a2]{background:#dedede;font-weight:200;font-size:13px;border-radius:10px 5px 5px 10px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:0}.feed-box_base_etiqueta_text.article a[data-v-0ece00a2]{color:#000!important}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/feed/index.vue"],"names":[],"mappings":"AACA,wBACE,wBAA4B,CAC7B,AACD,uBACE,sBAAyB,CAC1B,AACD,+BACI,eAAiB,CACpB,AACD,sCACM,eAAgB,AAChB,uBAAyB,AACzB,eAAiB,AACjB,oCAAqC,AAC7B,4BAA6B,AACrC,cAAe,AACf,cAAgB,CACrB,AACD,2CACQ,gBAAiB,AACjB,mBAAoB,AACpB,iBAAkB,AAClB,mBAAoB,AACpB,WAAa,AACb,eAAiB,CACxB,AACD,0BACI,cAAiB,AACjB,mBAAoB,AACpB,YAAa,AACb,YAAa,AACb,mBAAqB,CACxB,AACD,2BAGI,mBAAoB,AACpB,aAAc,AACd,wBAA0B,CAK7B,AACD,2DAVI,WAAY,AACZ,YAAa,AAIb,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAqBlC,AAnBD,gCAGM,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAKd,oBAAqB,AACjB,YAAa,AACjB,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,yCACQ,UAAY,CACnB,AACD,8CACU,iBAAkB,AAClB,mBAAoB,AACpB,WAAa,AACb,gBAAiB,AACjB,UAAY,CACrB,AACD,mDACY,kBAAoB,CAC/B,AACD,qDACY,iBAAmB,CAC9B,AACD,8CACU,eAAgB,AAChB,iBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AACpB,WAAa,AACb,eAAiB,CAC1B,AACD,mDACY,kBAAoB,CAC/B,AACD,qDACY,eAAoB,CAC/B,AACD,uDACY,UAAY,CACvB,AACD,6DACc,mBAAoB,AACpB,wBAA0B,CACvC,AACD,oDACY,+BAAgC,AACxB,sBAAwB,CAC3C,AACD,8CACU,eAAgB,AAChB,iBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AACpB,WAAa,AACb,gBAAiB,AACjB,YAAgB,CACzB,AACD,kDACY,iCAAkC,AAC1B,wBAA0B,CAC7C,AACD,mDACY,kBAAoB,CAC/B,AACD,qDACY,eAAoB,CAC/B,AACD,uDACY,UAAY,CACvB,AACD,6DACc,mBAAoB,AACpB,wBAA0B,CACvC,AACD,oDACY,+BAAgC,AACxB,sBAAwB,CAC3C,AACD,8CACU,iBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,YAAiB,AACjB,aAAiB,CAC1B,AACD,iEACY,UAAY,CACvB,AACD,uEACY,gBAAiB,AACjB,kBAAoB,CAC/B,AACD,uEACY,gBAAiB,AACjB,kBAAoB,CAC/B,AACD,sDACY,mBAAoB,AACpB,gBAAiB,AACjB,eAAgB,AAChB,gCAAiC,AACjC,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,eAAmB,CAC9B,AACD,wDACc,oBAAwB,CACrC","file":"index.vue","sourcesContent":["\n.borda[data-v-0ece00a2] {\n  border: 1px solid royalblue;\n}\n.feed[data-v-0ece00a2] {\n  height: 409px !important;\n}\n.feed-content[data-v-0ece00a2] {\n    max-height: 100%;\n}\n.feed-content__title[data-v-0ece00a2] {\n      cursor: pointer;\n      -webkit-transition: 0.3s;\n      transition: 0.3s;\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n      color: #255F83;\n      font-size: 14px;\n}\n.feed-content__title span[data-v-0ece00a2] {\n        font-weight: 900;\n        background: #1483a0;\n        padding: 5px 15px;\n        border-radius: 50px;\n        color: white;\n        font-weight: 300;\n}\n.feed hr[data-v-0ece00a2] {\n    margin: 15px 0px;\n    background: #dadada;\n    border: none;\n    padding: 1px;\n    border-radius: 100px;\n}\n.feed-box[data-v-0ece00a2] {\n    width: 100%;\n    height: 100%;\n    border-radius: 15px;\n    padding: 10px;\n    border: 1px solid #bfbfbf;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.feed-box_base[data-v-0ece00a2] {\n      width: 100%;\n      height: 100%;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-flex: 1;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.feed-box_base_etiqueta[data-v-0ece00a2] {\n        width: 100%;\n}\n.feed-box_base_etiqueta_tipe[data-v-0ece00a2] {\n          padding: 5px 25px;\n          border-radius: 50px;\n          color: white;\n          font-weight: 300;\n          width: 100%;\n}\n.feed-box_base_etiqueta_tipe.blue[data-v-0ece00a2] {\n            background: #0E9AAA;\n}\n.feed-box_base_etiqueta_tipe.orange[data-v-0ece00a2] {\n            background: orange;\n}\n.feed-box_base_etiqueta_next[data-v-0ece00a2] {\n          cursor: pointer;\n          padding: 5px 12px;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          border-radius: 50px;\n          color: white;\n          font-weight: 300;\n}\n.feed-box_base_etiqueta_next.blue[data-v-0ece00a2] {\n            background: #0E9AAA;\n}\n.feed-box_base_etiqueta_next.orange[data-v-0ece00a2] {\n            background: #FF6600;\n}\n.feed-box_base_etiqueta_next.disabled[data-v-0ece00a2] {\n            color: #AAA;\n}\n.feed-box_base_etiqueta_next.disabled[data-v-0ece00a2]:hover {\n              cursor: not-allowed;\n              background-color: #6f6f6f;\n}\n.feed-box_base_etiqueta_next[data-v-0ece00a2]:hover {\n            -webkit-filter: brightness(1.5);\n                    filter: brightness(1.5);\n}\n.feed-box_base_etiqueta_prev[data-v-0ece00a2] {\n          cursor: pointer;\n          padding: 5px 12px;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          border-radius: 50px;\n          color: white;\n          font-weight: 300;\n          margin: 0px 5px;\n}\n.feed-box_base_etiqueta_prev img[data-v-0ece00a2] {\n            -webkit-transform: rotate(180deg);\n                    transform: rotate(180deg);\n}\n.feed-box_base_etiqueta_prev.blue[data-v-0ece00a2] {\n            background: #0E9AAA;\n}\n.feed-box_base_etiqueta_prev.orange[data-v-0ece00a2] {\n            background: #FF6600;\n}\n.feed-box_base_etiqueta_prev.disabled[data-v-0ece00a2] {\n            color: #AAA;\n}\n.feed-box_base_etiqueta_prev.disabled[data-v-0ece00a2]:hover {\n              cursor: not-allowed;\n              background-color: #6f6f6f;\n}\n.feed-box_base_etiqueta_prev[data-v-0ece00a2]:hover {\n            -webkit-filter: brightness(1.5);\n                    filter: brightness(1.5);\n}\n.feed-box_base_etiqueta_text[data-v-0ece00a2] {\n          max-height: 115px;\n          min-height: 115px;\n          overflow-y: scroll;\n          overflow-x: hidden;\n          font-size: 14px;\n          font-weight: 300;\n          line-height: 17px;\n          padding: 5px 5px;\n          margin: 10px 0px;\n}\n.feed-box_base_etiqueta_text[data-v-0ece00a2]::-webkit-scrollbar {\n            width: 10px;\n}\n.feed-box_base_etiqueta_text[data-v-0ece00a2]::-webkit-scrollbar-thumb {\n            background: #666;\n            border-radius: 20px;\n}\n.feed-box_base_etiqueta_text[data-v-0ece00a2]::-webkit-scrollbar-track {\n            background: #ddd;\n            border-radius: 20px;\n}\n.feed-box_base_etiqueta_text.article[data-v-0ece00a2] {\n            background: #dedede;\n            font-weight: 200;\n            font-size: 13px;\n            border-radius: 10px 5px 5px 10px;\n            -webkit-box-orient: vertical;\n            -webkit-box-direction: normal;\n                -ms-flex-direction: column;\n                    flex-direction: column;\n            margin-bottom: 0px;\n}\n.feed-box_base_etiqueta_text.article a[data-v-0ece00a2] {\n              color: black !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content shadow-box sidebar-margin container column hidden feed"},[_c('div',{staticClass:"feed-content__title animation-fade animation-delay-1 container"},[_vm._m(0),_c('div',{staticStyle:{"font-size":"13px","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$toDate(new Date(_vm.article.publishedDate)))+"\n        ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"container feed-box"},[_c('div',{staticClass:"feed-box_base"},[_c('div',{staticClass:"container feed-box_base_etiqueta"},[_c('div',{staticClass:"feed-box_base_etiqueta_tipe blue"},[_vm._v("\n            Notice\n          ")]),_vm._v(" "),_c('div',{staticClass:"feed-box_base_etiqueta_prev blue",class:{ disabled: !_vm.canBack },on:{"click":function($event){return _vm.prevItem()}}},[_c('img',{attrs:{"src":__webpack_require__(661),"height":"13px","alt":"Previous"}})]),_vm._v(" "),_c('div',{staticClass:"feed-box_base_etiqueta_next blue",class:{ disabled: !_vm.canNext },on:{"click":function($event){return _vm.nextItem()}}},[_c('img',{attrs:{"src":__webpack_require__(661),"height":"13px","alt":"Next"}})])]),_vm._v(" "),_c('div',{staticClass:"container container feed-box_base_etiqueta_text"},[_vm._v("\n          "+_vm._s(_vm.article.title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"feed-box_base"},[_c('div',{staticClass:"container feed-box_base_etiqueta"},[_c('div',{staticClass:"feed-box_base_etiqueta_tipe orange"},[_vm._v("\n            Article\n          ")]),_vm._v(" "),_c('div',{staticClass:"feed-box_base_etiqueta_prev orange",class:{ disabled: !_vm.canBackContent },on:{"click":function($event){return _vm.prevContent()}}},[_c('img',{attrs:{"src":__webpack_require__(661),"height":"13px","alt":"Previous"}})]),_vm._v(" "),_c('div',{staticClass:"feed-box_base_etiqueta_next orange",class:{ disabled: !_vm.canNextContent },on:{"click":function($event){return _vm.nextContent()}}},[_c('img',{attrs:{"src":__webpack_require__(661),"height":"13px","alt":"Next"}})])]),_vm._v(" "),_c('div',{staticClass:"container container feed-box_base_etiqueta_text article",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("News")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(799);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_729d931e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(893);
function injectStyle (ssrContext) {
  __webpack_require__(891)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-729d931e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_729d931e_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(892);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("214802dd", content, true, {});

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".arrow-way[data-v-729d931e]{background:#ccc;width:20px;min-width:20px;height:20px;border-radius:50%;font-size:14px;opacity:.5;cursor:pointer;-webkit-transition:.1s;transition:.1s}.arrow-way.arrow-left[data-v-729d931e]{margin-right:2px}.arrow-way.arrow-right[data-v-729d931e]{margin-left:2px}.arrow-way[data-v-729d931e]:hover{opacity:1}.arrow-way svg[data-v-729d931e]{vertical-align:-.25em}.userinfo--container__stats[data-v-729d931e]{z-index:3;position:inherit}.userinfo--container__stats .userinfo--container__stats--bg[data-v-729d931e]{width:230px;height:100px;max-width:90%;background:rgba(0,0,0,.1);border-radius:100px 100px 0 0}.userinfo--container__stats .userinfo--container__stats--bg--2[data-v-729d931e]{width:235px;height:100px;max-width:90%;background:#fff;border-radius:100px 100px 0 0;margin:0 auto;position:relative}.userinfo--stats[data-v-729d931e]{position:absolute;top:-54px;left:0;width:100%;height:140px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:4}.userinfo--stats img[data-v-729d931e]{width:100px;top:2px;position:absolute}.percent--user[data-v-729d931e]{position:absolute;top:0;left:0;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.userinfo--container[data-v-729d931e]{position:relative}.userinfo--container .userinfo--container__box[data-v-729d931e]{position:relative;margin-bottom:20px;padding:15px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:20px;background-color:#fff;-webkit-box-shadow:10px 10px 37px 0 rgba(0,0,0,.19),0 8px 8px 0 rgba(0,0,0,.09);box-shadow:10px 10px 37px 0 rgba(0,0,0,.19),0 8px 8px 0 rgba(0,0,0,.09)}.userinfo--container .userinfo--container__box .userinfo--container__box--class[data-v-729d931e]{width:100%;padding-top:68px;text-align:center;z-index:5}.userinfo--container .userinfo--container__box .userinfo--container__box--class .class-name[data-v-729d931e]{width:100%;background:#efefef;height:20px;border-radius:20px;font-size:14px;font-weight:300;letter-spacing:2px;border:1px solid gray;text-transform:uppercase;display:flex;display:-webkit-box;display:-ms-flexbox;align-items:center;-webkit-box-align:center;-ms-flex-align:center;justify-content:center;-webkit-box-pack:center;-ms-flex-pack:center}.userinfo--container .userinfo--container__box .userinfo--container__box--class .class-name a[data-v-729d931e]{color:gray!important}.userinfo--container .userinfo--container__box .userinfo--container__box--class img[data-v-729d931e]{margin:0 5px 0 0;height:21px}.userinfo--container .userinfo--container__box .userinfo--container__box--btn[data-v-729d931e]{width:100%;margin:5px 0}.levelNumbers[data-v-729d931e]{position:absolute;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;top:0;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;z-index:3}.levelNumbers .actualLevel[data-v-729d931e]{border-radius:0 30px 30px 0;border-left-width:0!important;border:1px solid #981fff;color:#981fff}.levelNumbers .actualLevel[data-v-729d931e],.levelNumbers .targetLevel[data-v-729d931e]{-ms-flex-preferred-size:30px;flex-basis:30px;max-width:70px;margin:20px 0;height:23px;background:#fff;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.levelNumbers .targetLevel[data-v-729d931e]{border-radius:30px 0 0 30px;border-right-width:0!important;border:1px solid #ff8c00;color:#ff8c00}.levelNumbers .nowLevel[data-v-729d931e]{border-radius:0 30px 30px 0;border-left-width:0!important;background:#fff;border:1px solid #42007a;color:#8609f0}.levelNumbers .nextLevel[data-v-729d931e],.levelNumbers .nowLevel[data-v-729d931e]{-ms-flex-preferred-size:30px;flex-basis:30px;max-width:70px;margin:48px 0;height:23px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.levelNumbers .nextLevel[data-v-729d931e]{border-radius:30px 0 0 30px;border-right-width:0!important;border:1px solid #ff8c00;color:#ff8c00}.experienceBox[data-v-729d931e]{margin:5px 0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%}.experienceBox img[data-v-729d931e]{margin:0 5px 0 0}.experienceBox #xp[data-v-729d931e]{padding:2px 9px;font-weight:200;font-size:15px;text-align:center;color:#525252;border:1px solid gray;border-radius:300px;width:100%}.mdscoinsBox[data-v-729d931e]{margin:0 0 5px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%}.mdscoinsBox img[data-v-729d931e]{margin:0 5px 0 0}.mdscoinsBox #coin[data-v-729d931e]{padding:2px 9px;font-weight:200;background:#ffcb00;color:#624900;font-size:15px;text-align:center;border:1px solid #866e0d;border-radius:300px;width:100%}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/userProperties/index.vue"],"names":[],"mappings":"AACA,4BACE,gBAAiB,AACjB,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,WAAa,AACb,eAAgB,AAChB,uBAAyB,AACzB,cAAiB,CAClB,AACD,uCACI,gBAAkB,CACrB,AACD,wCACI,eAAiB,CACpB,AACD,kCACI,SAAW,CACd,AACD,gCACI,qBAAyB,CAC5B,AACD,6CACE,UAAW,AACX,gBAAkB,CACnB,AACD,6EACI,YAAa,AACb,aAAc,AACd,cAAe,AACf,0BAA+B,AAC/B,6BAA+B,CAClC,AACD,gFACI,YAAa,AACb,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,8BAA+B,AAC/B,cAAe,AACf,iBAAmB,CACtB,AACD,kCACE,kBAAmB,AACnB,UAAW,AACX,OAAU,AACV,WAAY,AACZ,aAAc,AACd,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AAC1B,sBAAuB,AACvB,mBAAoB,AACpB,wBAAyB,AACzB,qBAAsB,AACtB,uBAAwB,AACxB,SAAW,CACZ,AACD,sCACI,YAAa,AACb,QAAS,AACT,iBAAmB,CACtB,AACD,gCACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AAC1B,sBAAuB,AACvB,mBAAoB,AACpB,wBAAyB,AACzB,qBAAsB,AACtB,sBAAwB,CACzB,AACD,sCACE,iBAAmB,CACpB,AACD,gEACI,kBAAmB,AACnB,mBAAoB,AACpB,aAAc,AACd,8BAA+B,AAC/B,sBAAuB,AACvB,mBAAoB,AACpB,sBAAuB,AACvB,gFAA0F,AAC1F,uEAAkF,CACrF,AACD,iGACM,WAAY,AACZ,iBAAkB,AAClB,kBAAmB,AACnB,SAAW,CAChB,AACD,6GACQ,WAAY,AACZ,mBAAoB,AACpB,YAAa,AACb,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,sBAAuB,AACvB,yBAA0B,AAC1B,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,mBAAoB,AACpB,yBAA0B,AAC1B,sBAAuB,AACvB,uBAAwB,AACxB,wBAAyB,AACzB,oBAAsB,CAC7B,AACD,+GACU,oBAAuB,CAChC,AACD,qGACQ,iBAAwB,AACxB,WAAa,CACpB,AACD,+FACM,WAAY,AACZ,YAAgB,CACrB,AACD,+BACE,kBAAmB,AACnB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AAEpB,MAAO,AACP,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AAEvC,SAAW,CACZ,AACD,4CAKI,4BAAkC,AAClC,8BAAkC,AAGlC,yBAA0B,AAC1B,aAAe,CAalB,AACD,wFAvBI,6BAA8B,AAC1B,gBAAiB,AACrB,eAAgB,AAChB,cAAiB,AAGjB,YAAa,AACb,gBAAkB,AAGlB,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAyBjB,AAvBD,4CAKI,4BAAmC,AACnC,+BAAmC,AAGnC,yBAA6B,AAC7B,aAAkB,CAarB,AACD,yCAKI,4BAAkC,AAClC,8BAAkC,AAElC,gBAAkB,AAClB,yBAA0B,AAC1B,aAAe,CAalB,AACD,mFAvBI,6BAA8B,AAC1B,gBAAiB,AACrB,eAAgB,AAChB,cAAiB,AAGjB,YAAa,AAIb,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAwBjB,AAtBD,0CAKI,4BAAmC,AACnC,+BAAmC,AAEnC,yBAA6B,AAC7B,aAAkB,CAarB,AACD,gCACE,aAAwB,AACxB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,UAAY,CACb,AACD,oCACI,gBAAwB,CAC3B,AACD,oCACI,gBAAiB,AACjB,gBAAiB,AACjB,eAAgB,AAChB,kBAAmB,AACnB,cAAe,AACf,sBAAuB,AACvB,oBAAqB,AACrB,UAAY,CACf,AACD,8BACE,eAAwB,AACxB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,UAAY,CACb,AACD,kCACI,gBAAwB,CAC3B,AACD,oCACI,gBAAiB,AACjB,gBAAiB,AACjB,mBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,yBAA0B,AAC1B,oBAAqB,AACrB,UAAY,CACf","file":"index.vue","sourcesContent":["\n.arrow-way[data-v-729d931e] {\n  background: #ccc;\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 14px;\n  opacity: 0.5;\n  cursor: pointer;\n  -webkit-transition: 0.1s;\n  transition: 0.1s;\n}\n.arrow-way.arrow-left[data-v-729d931e] {\n    margin-right: 2px;\n}\n.arrow-way.arrow-right[data-v-729d931e] {\n    margin-left: 2px;\n}\n.arrow-way[data-v-729d931e]:hover {\n    opacity: 1;\n}\n.arrow-way svg[data-v-729d931e] {\n    vertical-align: -0.250em;\n}\n.userinfo--container__stats[data-v-729d931e] {\n  z-index: 3;\n  position: inherit;\n}\n.userinfo--container__stats .userinfo--container__stats--bg[data-v-729d931e] {\n    width: 230px;\n    height: 100px;\n    max-width: 90%;\n    background: rgba(0, 0, 0, 0.1);\n    border-radius: 100px 100px 0 0;\n}\n.userinfo--container__stats .userinfo--container__stats--bg--2[data-v-729d931e] {\n    width: 235px;\n    height: 100px;\n    max-width: 90%;\n    background: #fff;\n    border-radius: 100px 100px 0 0;\n    margin: 0 auto;\n    position: relative;\n}\n.userinfo--stats[data-v-729d931e] {\n  position: absolute;\n  top: -54px;\n  left: 0px;\n  width: 100%;\n  height: 140px;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  z-index: 4;\n}\n.userinfo--stats img[data-v-729d931e] {\n    width: 100px;\n    top: 2px;\n    position: absolute;\n}\n.percent--user[data-v-729d931e] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.userinfo--container[data-v-729d931e] {\n  position: relative;\n}\n.userinfo--container .userinfo--container__box[data-v-729d931e] {\n    position: relative;\n    margin-bottom: 20px;\n    padding: 15px;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    border-radius: 20px;\n    background-color: #fff;\n    -webkit-box-shadow: 10px 10px 37px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);\n    box-shadow: 10px 10px 37px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);\n}\n.userinfo--container .userinfo--container__box .userinfo--container__box--class[data-v-729d931e] {\n      width: 100%;\n      padding-top: 68px;\n      text-align: center;\n      z-index: 5;\n}\n.userinfo--container .userinfo--container__box .userinfo--container__box--class .class-name[data-v-729d931e] {\n        width: 100%;\n        background: #efefef;\n        height: 20px;\n        border-radius: 20px;\n        font-size: 14px;\n        font-weight: 300;\n        letter-spacing: 2px;\n        border: 1px solid gray;\n        text-transform: uppercase;\n        display: flex;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n}\n.userinfo--container .userinfo--container__box .userinfo--container__box--class .class-name a[data-v-729d931e] {\n          color: gray !important;\n}\n.userinfo--container .userinfo--container__box .userinfo--container__box--class img[data-v-729d931e] {\n        margin: 0px 5px 0px 0px;\n        height: 21px;\n}\n.userinfo--container .userinfo--container__box .userinfo--container__box--btn[data-v-729d931e] {\n      width: 100%;\n      margin: 5px 0px;\n}\n.levelNumbers[data-v-729d931e] {\n  position: absolute;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  /* height: 100%; */\n  top: 0;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  /* align-items: center; */\n  z-index: 3;\n}\n.levelNumbers .actualLevel[data-v-729d931e] {\n    -ms-flex-preferred-size: 30px;\n        flex-basis: 30px;\n    max-width: 70px;\n    margin: 20px 0px;\n    border-radius: 00px 30px 30px 0px;\n    border-left-width: 0px !important;\n    height: 23px;\n    background: white;\n    border: 1px solid #981fff;\n    color: #981fff;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.levelNumbers .targetLevel[data-v-729d931e] {\n    -ms-flex-preferred-size: 30px;\n        flex-basis: 30px;\n    max-width: 70px;\n    margin: 20px 0px;\n    border-radius: 30px 00px 00px 30px;\n    border-right-width: 0px !important;\n    height: 23px;\n    background: white;\n    border: 1px solid darkorange;\n    color: darkorange;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.levelNumbers .nowLevel[data-v-729d931e] {\n    -ms-flex-preferred-size: 30px;\n        flex-basis: 30px;\n    max-width: 70px;\n    margin: 48px 0px;\n    border-radius: 00px 30px 30px 0px;\n    border-left-width: 0px !important;\n    height: 23px;\n    background: white;\n    border: 1px solid #42007a;\n    color: #8609f0;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.levelNumbers .nextLevel[data-v-729d931e] {\n    -ms-flex-preferred-size: 30px;\n        flex-basis: 30px;\n    max-width: 70px;\n    margin: 48px 0px;\n    border-radius: 30px 00px 00px 30px;\n    border-right-width: 0px !important;\n    height: 23px;\n    border: 1px solid darkorange;\n    color: darkorange;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.experienceBox[data-v-729d931e] {\n  margin: 5px 0px 5px 0px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  width: 100%;\n}\n.experienceBox img[data-v-729d931e] {\n    margin: 0px 5px 0px 0px;\n}\n.experienceBox #xp[data-v-729d931e] {\n    padding: 2px 9px;\n    font-weight: 200;\n    font-size: 15px;\n    text-align: center;\n    color: #525252;\n    border: 1px solid gray;\n    border-radius: 300px;\n    width: 100%;\n}\n.mdscoinsBox[data-v-729d931e] {\n  margin: 0px 0px 5px 0px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  width: 100%;\n}\n.mdscoinsBox img[data-v-729d931e] {\n    margin: 0px 5px 0px 0px;\n}\n.mdscoinsBox #coin[data-v-729d931e] {\n    padding: 2px 9px;\n    font-weight: 200;\n    background: #ffcb00;\n    color: #624900;\n    font-size: 15px;\n    text-align: center;\n    border: 1px solid #866e0d;\n    border-radius: 300px;\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 893:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container wrap container--translate--words"},[_c('div',{staticClass:"userinfo--container flex-grow-1 sidebar-margin"},[_c('div',{staticClass:"userinfo--container__stats container align-items-center justify-content-center"},[_c('div',{staticClass:"userinfo--container__stats--bg"},[_c('div',{staticClass:"userinfo--container__stats--bg--2"},[_c('svg',{staticClass:"circular-chart",attrs:{"width":"250","x":"0px","y":"0px","viewBox":"0 0 36 36","xml:space":"preserve"}},[_c('path',{staticClass:"circle2",attrs:{"stroke-dasharray":"55, 100","d":"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"}}),_vm._v(" "),_c('path',{staticClass:"circle",attrs:{"stroke-dasharray":((parseInt((_vm.user.xp * 55) / _vm.getTotal(_vm.user.level))) + ", 100"),"d":"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"}}),_vm._v(" "),_c('defs',[_c('linearGradient',{attrs:{"id":"MyGradient"}},[_c('stop',{attrs:{"offset":"50%","stop-color":"#7F00FD"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#FFA200"}})],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"userinfo--container__box container column justify-content-center align-items-center"},[_c('div',{staticClass:"levelNumbers"},[_c('div',{staticClass:"actualLevel",attrs:{"id":""}},[_vm._v(_vm._s(parseInt(_vm.user.xp)))]),_vm._v(" "),_c('div',{staticClass:"targetLevel"},[_vm._v(_vm._s(_vm.getTotal(_vm.user.level)))])]),_vm._v(" "),_c('div',{staticClass:"levelNumbers"},[_c('div',{staticClass:"nowLevel",attrs:{"id":""}},[_c('span',{staticStyle:{"font-size":"11px","color":"darkorange"}},[_vm._v("LEVEL ")]),_vm._v(_vm._s(_vm.user.level))]),_vm._v(" "),_c('div',{staticClass:"nextLevel"},[_c('span',{staticStyle:{"font-size":"11px","color":"#981fff"}},[_vm._v("LEVEL ")]),_vm._v(_vm._s(_vm.user.level + 1))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userinfo--container__box--class container justify-content-center animation-fade animation-delay-1"},[_c('img',{attrs:{"src":__webpack_require__(720),"width":"21","alt":"Minds"}}),_vm._v(" "),_c('div',{staticClass:"class-name"},[_c('router-link',{attrs:{"to":"/niveis"}},[_vm._v(_vm._s(_vm.getLevelName(_vm.user.level)))])],1)]),_vm._v(" "),_c('div',{staticClass:"container experienceBox"},[_c('img',{attrs:{"src":__webpack_require__(724),"width":"21","alt":"Minds"}}),_vm._v(" "),_c('div',{attrs:{"id":"xp"}},[_vm._v("Experience"),_c('i',{staticClass:"margin-left-5 fas fa-arrow-right",staticStyle:{"margin":"0px 5px","font-size":"10px"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(parseInt(_vm.xp)))])])]),_vm._v(" "),_c('div',{staticClass:"container mdscoinsBox"},[_c('img',{attrs:{"src":__webpack_require__(679),"width":"21","alt":"Minds"}}),_vm._v(" "),_c('div',{attrs:{"id":"coin"}},[_vm._v("Mds Coins"),_c('i',{staticClass:"margin-left-5 fas fa-arrow-right",staticStyle:{"margin-left":"0px 5px","font-size":"10px"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.score))])])]),_vm._v(" "),(!_vm.$store.getters['student/GET'].teens)?_c('div',{staticClass:"userinfo--container__box--btn container justify-content-center animation-bottom animation-delay-1"},[_c('router-link',{staticClass:"btn btn-md btn-red btn-full btn-rounded",attrs:{"to":{ name: 'review' }}},[_vm._v("\r\n          PRACTICE "),_c('i',{staticClass:"margin-left-5 fas fa-arrow-right"})])],1):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userinfo--stats animation-fade animation-delay-1"},[_c('img',{attrs:{"src":__webpack_require__(660),"alt":"Minds"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-app col-12 col-xl-3 col-lg-3 col-md-4 col-sm-12 container column"},[_c('userProperties',{staticClass:"animation-top animation-delay-01",attrs:{"user":_vm.student}}),_vm._v(" "),_c('feed',{staticClass:"animation-top animation-delay-05"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 895:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPdf_vue__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15957670_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPdf_vue__ = __webpack_require__(902);
function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15957670"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15957670_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(897);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("f77830c4", content, true, {});

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".modal-pdf[data-v-15957670]{height:100vh;width:100vw;position:fixed;top:0;left:0;z-index:125}.modal-pdf__close[data-v-15957670]{width:100%;padding-bottom:5px}.modal-pdf__close button#back_pdf svg[data-v-15957670],.modal-pdf__close button#close_pdf svg[data-v-15957670]{font-size:32px}.modal-pdf__box[data-v-15957670]{width:calc(100% - 20px);border:5px solid #c2003c;border-radius:15px;margin:10px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:baseline;align-content:baseline}.modal-pdf__box__item[data-v-15957670]{background-color:hsla(0,0%,100%,.25);border:5px solid #c2003c;border-radius:15px;width:145px;height:125px}.modal-pdf__box.modal-pdf__box--pdf[data-v-15957670]{border:0}.modal-pdf__box.modal-pdf__box--pdf iframe[data-v-15957670]{width:100%;height:100%}@media (max-width:524px){.modal-pdf__box.modal-pdf__box--pdf[data-v-15957670]{width:100%;margin:0;border:none;border-radius:0;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/modal/modalPdf.vue"],"names":[],"mappings":"AACA,4BACE,aAAc,AACd,YAAa,AACb,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,WAAa,CACd,AACD,mCACI,WAAY,AACZ,kBAAoB,CACvB,AACD,+GAEM,cAAgB,CACrB,AACD,iCACI,wBAAyB,AACzB,yBAA0B,AAC1B,mBAAoB,AACpB,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,4BAA6B,AACzB,sBAAwB,CAC/B,AACD,uCACM,qCAA4C,AAC5C,yBAA0B,AAC1B,mBAAoB,AACpB,YAAa,AACb,YAAc,CACnB,AACD,qDACM,QAAU,CACf,AACD,4DACQ,WAAY,AACZ,WAAa,CACpB,AACD,yBACA,qDACU,WAAY,AACZ,SAAU,AACV,YAAa,AACb,gBAAiB,AACjB,uBAAwB,AACpB,oBAAqB,AACjB,qBAAuB,CACxC,CACA","file":"modalPdf.vue","sourcesContent":["\n.modal-pdf[data-v-15957670] {\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 125;\n}\n.modal-pdf__close[data-v-15957670] {\n    width: 100%;\n    padding-bottom: 5px;\n}\n.modal-pdf__close button#close_pdf svg[data-v-15957670],\n    .modal-pdf__close button#back_pdf svg[data-v-15957670] {\n      font-size: 32px;\n}\n.modal-pdf__box[data-v-15957670] {\n    width: calc(100% - 20px);\n    border: 5px solid #C2003C;\n    border-radius: 15px;\n    margin: 10px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -ms-flex-line-pack: baseline;\n        align-content: baseline;\n}\n.modal-pdf__box__item[data-v-15957670] {\n      background-color: rgba(255, 255, 255, 0.25);\n      border: 5px solid #C2003C;\n      border-radius: 15px;\n      width: 145px;\n      height: 125px;\n}\n.modal-pdf__box.modal-pdf__box--pdf[data-v-15957670] {\n      border: 0;\n}\n.modal-pdf__box.modal-pdf__box--pdf iframe[data-v-15957670] {\n        width: 100%;\n        height: 100%;\n}\n@media (max-width: 524px) {\n.modal-pdf__box.modal-pdf__box--pdf[data-v-15957670] {\n          width: 100%;\n          margin: 0;\n          border: none;\n          border-radius: 0;\n          -webkit-box-pack: start;\n              -ms-flex-pack: start;\n                  justify-content: start;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Initial Class Minds.pdf": 899,
	"./PDF AULA INICIAL.pdf": 900,
	"./guia de ensino.pdf": 901,
	"./initialClass.mp4": 771,
	"./notification.mp3": 871
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 898;

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Initial Class Minds.f4ce0d7.pdf";

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PDF AULA INICIAL.38eca10.pdf";

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/guia de ensino.650075b.pdf";

/***/ }),

/***/ 902:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal-pdf bg-color container column justify-content-center align-items-center"},[_c('div',{staticClass:"modal-pdf__close container padding-10 justify-content-end"},[_c('button',{staticClass:"btn btn-sm btn-blue btn-rounded",attrs:{"id":"close_pdf"},on:{"click":function($event){return _vm.$store.commit('setShowPdf', false)}}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),_vm._v(" "),(!_vm.pdf)?_c('div',{staticClass:"modal-pdf__box flex-grow-1 container wrap"},[_c('div',{staticClass:"modal-pdf__box__item container column align-items-center justify-content-between padding-10 margin-10"},[_c('h5',{staticClass:"margin-bottom-10"},[_vm._v("Initial Class")]),_vm._v(" "),_c('button',{staticClass:"btn btn-md btn-yellow btn-rounded",on:{"click":function($event){return _vm.showPdf('Initial Class Minds.pdf')}}},[_vm._v("\n          Read\n        ")])]),_vm._v(" "),_c('div',{staticClass:"modal-pdf__box__item container column align-items-center justify-content-between padding-10 margin-10"},[_c('h5',{staticClass:"margin-bottom-10"},[_vm._v("Teaching Guide")]),_vm._v(" "),_c('button',{staticClass:"btn btn-md btn-yellow btn-rounded",on:{"click":function($event){return _vm.showPdf('guia de ensino.pdf')}}},[_vm._v("\n          Read\n        ")])])]):_c('div',{staticClass:"modal-pdf__box modal-pdf__box--pdf flex-grow-1"},[_c('iframe',{attrs:{"src":_vm.pdfSrc}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.0a95da3b2aabb9e30c6d.js